const AkamaiDeploymentConfigPlatform = {
    akamai: 'akamai'
};
const Delimiter = {
    '-': '-',
    '.': '.'
};
const AkamaiIntegrationPlatform = {
    akamai: 'akamai'
};
const ApplicationAuditLogAction = {
    create: 'create',
    update: 'update',
    delete: 'delete'
};
const ApplicationAuditLogResult = {
    success: 'success',
    failure: 'failure'
};
const ApplicationAuditLogType = {
    environment: 'environment',
    deployment: 'deployment',
    variables: 'variables',
    dependencies: 'dependencies',
    tag: 'tag',
    'tag-condition': 'tag-condition',
    version: 'version',
    integration: 'integration',
    'environment-members': 'environment-members',
    settings: 'settings'
};
const ApplicationProjectRefVisibility = {
    public: 'public',
    private: 'private'
};
const ComparisonOperator = {
    is: 'is',
    is_not: 'is not'
};
const TagChannel = {
    branch: 'branch',
    version: 'version',
    user: 'user',
    isCI: 'isCI',
    target: 'target',
    gitTag: 'gitTag',
    environment: 'environment'
};
const Operator = {
    AND: 'AND',
    OR: 'OR'
};
const ApplicationVersionStatus = {
    available: 'available',
    deprecated: 'deprecated',
    failed: 'failed',
    rolled_back: 'rolled_back',
    unavailable: 'unavailable'
};
const ApplicationVersionDependenciesItemType = {
    dependency: 'dependency',
    devDependency: 'devDependency',
    peerDependency: 'peerDependency',
    optionalDependency: 'optionalDependency'
};
const AuditLogAction = {
    create: 'create',
    update: 'update',
    delete: 'delete',
    promote: 'promote',
    rollback: 'rollback',
    deploy: 'deploy'
};
const AuditLogResult = {
    success: 'success',
    failure: 'failure',
    pending: 'pending',
    cancelled: 'cancelled'
};
const AuditLogType = {
    deployment: 'deployment',
    promotion: 'promotion',
    rollback: 'rollback',
    configuration: 'configuration',
    integration: 'integration'
};
const AwsDeploymentConfigPlatform = {
    aws: 'aws'
};
const AwsIntegrationPlatform = {
    aws: 'aws'
};
const ChangeSubscriptionRequestNewBillingCycle = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const ChangeSubscriptionRequestNewTier = {
    PERSONAL: 'PERSONAL',
    TEAM: 'TEAM',
    PRO: 'PRO',
    ENTERPRISE: 'ENTERPRISE'
};
const CloudflareDeploymentConfigPlatform = {
    cloudflare: 'cloudflare'
};
const CloudflareIntegrationPlatform = {
    cloudflare: 'cloudflare'
};
const ContributorWithTypeType = {
    team: 'team',
    member: 'member'
};
const CouponDtoForcedCycle = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const CouponDtoForcedTier = {
    PERSONAL: 'PERSONAL',
    TEAM: 'TEAM',
    PRO: 'PRO',
    ENTERPRISE: 'ENTERPRISE'
};
const NetlifyIntegrationPlatform = {
    netlify: 'netlify'
};
const FastlyIntegrationPlatform = {
    fastly: 'fastly'
};
const KubernetesIntegrationPlatform = {
    kubernetes: 'kubernetes'
};
const CustomIntegrationPlatform = {
    custom: 'custom'
};
const MultiCdnIntegrationPlatform = {
    'multi-cdn': 'multi-cdn'
};
const ZephyrIntegrationPlatform = {
    zephyr: 'zephyr'
};
const DeploymentPlatform = {
    cloudflare: 'cloudflare',
    aws: 'aws',
    netlify: 'netlify',
    fastly: 'fastly',
    akamai: 'akamai',
    kubernetes: 'kubernetes',
    zephyr: 'zephyr',
    custom: 'custom',
    'multi-cdn': 'multi-cdn'
};
const CurrentUserOpenMembershipAutoJoinReason = {
    no_matching_organization: 'no_matching_organization',
    single_matching_organization: 'single_matching_organization',
    multiple_matching_organizations: 'multiple_matching_organizations'
};
const CurrentUserRole = {
    user: 'user',
    admin: 'admin',
    owner: 'owner'
};
const CustomDeploymentConfigPlatform = {
    custom: 'custom'
};
const DeployTarget = {
    environment: 'environment',
    tag: 'tag',
    releaseCandidate: 'releaseCandidate'
};
const NetlifyDeploymentConfigPlatform = {
    netlify: 'netlify'
};
const FastlyDeploymentConfigPlatform = {
    fastly: 'fastly'
};
const KubernetesDeploymentConfigPlatform = {
    kubernetes: 'kubernetes'
};
const DeploymentIntegrationType = {
    worker: 'worker',
    pages: 'pages'
};
const DeploymentStatus = {
    active: 'active',
    pending: 'pending',
    failed: 'failed',
    disabled: 'disabled'
};
const DnsCheckResultDtoStatus = {
    registered: 'registered',
    unregistered: 'unregistered'
};
const EntriEligibleResponsePowerStatus = {
    active: 'active',
    inactive: 'inactive'
};
const GraphMetricBodyDtoMetricsItem = {
    DEPLOYMENTS: 'DEPLOYMENTS'
};
const GraphMetricBodyDtoSpan = {
    hour: 'hour',
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year'
};
const GraphMetricResultDtoMetric = {
    DEPLOYMENTS: 'DEPLOYMENTS'
};
const GraphNodeDataEntityType = {
    version: 'version',
    tag: 'tag',
    environment: 'environment'
};
const GraphNodeDataStatus = {
    incomplete: 'incomplete',
    complete: 'complete'
};
const InviteInformationDtoCycle = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const InviteInformationDtoTier = {
    PERSONAL: 'PERSONAL',
    TEAM: 'TEAM',
    PRO: 'PRO',
    ENTERPRISE: 'ENTERPRISE'
};
const NavigationItemsType = {
    organization: 'organization',
    project: 'project',
    application: 'application'
};
const NewPeopleRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const NewProjectContributorType = {
    member: 'member',
    team: 'team'
};
const OrganizationDefaultRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const OrganizationSubscriptionTier = {
    PERSONAL: 'PERSONAL',
    TEAM: 'TEAM',
    PRO: 'PRO',
    ENTERPRISE: 'ENTERPRISE'
};
const OrganizationMemberRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const OrganizationMembershipDomainStatus = {
    pending: 'pending',
    verified: 'verified'
};
const OrganizationPeopleRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const OrganizationTeamRole = {
    maintainer: 'maintainer',
    member: 'member'
};
const PeopleRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const ProjectAuditLogAction = {
    create: 'create',
    update: 'update',
    delete: 'delete'
};
const ProjectAuditLogResult = {
    success: 'success',
    failure: 'failure'
};
const ProjectAuditLogType = {
    collaborators: 'collaborators',
    settings: 'settings',
    integration: 'integration',
    environment: 'environment',
    deployment: 'deployment',
    variables: 'variables',
    dependencies: 'dependencies',
    tag: 'tag',
    'tag-condition': 'tag-condition',
    'environment-members': 'environment-members',
    version: 'version'
};
const ProjectContributorRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const ProjectContributorResponseRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const ProjectContributorResponseType = {
    member: 'member',
    team: 'team'
};
const ResolutionMetadataSource = {
    packagejson: 'package.json',
    mfConfig: 'mfConfig'
};
const ResolvedDependencyWithMetadataDependencyType = {
    version: 'version',
    tag: 'tag',
    environment: 'environment',
    wildcard: 'wildcard'
};
const UserPinType = {
    application: 'application',
    organization: 'organization',
    project: 'project'
};
const SidePanelDeployTarget = {
    environment: 'environment',
    tag: 'tag'
};
const SimpleMetricQuotaDtoMetric = {
    DEPLOYMENTS: 'DEPLOYMENTS',
    SEATS: 'SEATS'
};
const StripeInvoiceDtoStatus = {
    draft: 'draft',
    open: 'open',
    paid: 'paid',
    uncollectible: 'uncollectible',
    void: 'void'
};
const SubscriptionDtoCycle = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const SubscriptionDtoScheduledTier = {
    PERSONAL: 'PERSONAL',
    TEAM: 'TEAM',
    PRO: 'PRO',
    ENTERPRISE: 'ENTERPRISE'
};
const SubscriptionDtoScheduleReason = {
    PAYMENT_FAILED: 'PAYMENT_FAILED',
    MANUAL_DOWNGRADE: 'MANUAL_DOWNGRADE'
};
const SubscriptionDtoTier = {
    PERSONAL: 'PERSONAL',
    TEAM: 'TEAM',
    PRO: 'PRO',
    ENTERPRISE: 'ENTERPRISE'
};
const TargetListItemType = {
    environment: 'environment',
    tag: 'tag'
};
const TeamRole = {
    maintainer: 'maintainer',
    member: 'member'
};
const TeamMemberRole = {
    maintainer: 'maintainer',
    member: 'member'
};
const TeamUserRole = {
    maintainer: 'maintainer',
    member: 'member'
};
const UpdateMemberRoleRole = {
    maintainer: 'maintainer',
    member: 'member'
};
const UpdatePeopleRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const UpdateProjectByIdVisibility = {
    public: 'public',
    private: 'private'
};
const UpdateProjectContributorRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const UpdateProjectContributorType = {
    member: 'member',
    team: 'team'
};
const UserApplicationListItemProjectVisibility = {
    public: 'public',
    private: 'private'
};
const UserPinVisibility = {
    public: 'public',
    private: 'private',
    internal: 'internal'
};
const UserProjectListItemVisibility = {
    public: 'public',
    private: 'private'
};
const VerifyOrganizationMembershipDomainResultReason = {
    invalid_code: 'invalid_code',
    expired: 'expired',
    code_not_sent: 'code_not_sent',
    attempts_exceeded: 'attempts_exceeded'
};
const VersionSortField = {
    user: 'user',
    buildVersion: 'buildVersion',
    published: 'published'
};
const GetHealth200Database = {
    connected: 'connected',
    disconnected: 'disconnected'
};
const GetHealth200Redis = {
    connected: 'connected',
    disconnected: 'disconnected',
    not_configured: 'not_configured'
};
const GetHealth200Status = {
    ok: 'ok',
    degraded: 'degraded',
    unhealthy: 'unhealthy'
};
const GetHealthLiveness200Status = {
    ok: 'ok'
};
const GetHealthReadiness200Status = {
    ready: 'ready',
    not_ready: 'not_ready'
};
const GetHealthReadiness503Status = {
    ready: 'ready',
    not_ready: 'not_ready'
};
const GetApplicationSummary401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationSummary401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationSummary403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationSummary403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationSummary404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationSummary404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationOverview401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationOverview401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationOverview403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationOverview403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationOverview404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationOverview404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationConsumers401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationConsumers401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationConsumers403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationConsumers403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationConsumers404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationConsumers404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationUmlSidebar401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationUmlSidebar401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationUmlSidebar403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationUmlSidebar403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationUmlSidebar404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationUmlSidebar404StatusCode = {
    NUMBER_404: 404
};
const GetProjectApplicationListByProjectNameSortOrder = {
    asc: 'asc',
    desc: 'desc'
};
const GetProjectApplicationListByProjectName401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectApplicationListByProjectName401StatusCode = {
    NUMBER_401: 401
};
const GetProjectApplicationListByProjectName403Error = {
    Forbidden: 'Forbidden'
};
const GetProjectApplicationListByProjectName403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationSidebarList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationSidebarList401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationSidebarList403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationSidebarList403StatusCode = {
    NUMBER_403: 403
};
const GetProjectApplicationSidebarList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectApplicationSidebarList401StatusCode = {
    NUMBER_401: 401
};
const GetProjectApplicationSidebarList403Error = {
    Forbidden: 'Forbidden'
};
const GetProjectApplicationSidebarList403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationListByProjectSortOrder = {
    asc: 'asc',
    desc: 'desc'
};
const GetApplicationListByProject401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationListByProject401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationListByProject403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationListByProject403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationSettings401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationSettings401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationSettings403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationSettings403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationSettings404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationSettings404StatusCode = {
    NUMBER_404: 404
};
const UpdateApplicationSettings401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateApplicationSettings401StatusCode = {
    NUMBER_401: 401
};
const UpdateApplicationSettings403Error = {
    Forbidden: 'Forbidden'
};
const UpdateApplicationSettings403StatusCode = {
    NUMBER_403: 403
};
const UpdateApplicationSettings404Error = {
    Not_Found: 'Not Found'
};
const UpdateApplicationSettings404StatusCode = {
    NUMBER_404: 404
};
const GetApplication401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplication401StatusCode = {
    NUMBER_401: 401
};
const GetApplication403Error = {
    Forbidden: 'Forbidden'
};
const GetApplication403StatusCode = {
    NUMBER_403: 403
};
const GetApplication404Error = {
    Not_Found: 'Not Found'
};
const GetApplication404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationModule401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationModule401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationModule403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationModule403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationModule404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationModule404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationContributors401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationContributors401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationContributors403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationContributors403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationContributors404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationContributors404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationContributorsWithVersionCountPeriod = {
    all: 'all',
    year: 'year',
    '6months': '6months',
    month: 'month',
    'current-month': 'current-month'
};
const GetApplicationContributorsWithVersionCount401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationContributorsWithVersionCount401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationContributorsWithVersionCount403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationContributorsWithVersionCount403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationContributorsWithVersionCount404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationContributorsWithVersionCount404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationActivityOverTimePeriod = {
    all: 'all',
    year: 'year',
    '6months': '6months',
    month: 'month',
    'current-month': 'current-month'
};
const GetApplicationActivityOverTime401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationActivityOverTime401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationActivityOverTime403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationActivityOverTime403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationActivityOverTime404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationActivityOverTime404StatusCode = {
    NUMBER_404: 404
};
const CreateApplication400Error = {
    Bad_Request: 'Bad Request'
};
const CreateApplication400StatusCode = {
    NUMBER_400: 400
};
const CreateApplication401Error = {
    Unauthorized: 'Unauthorized'
};
const CreateApplication401StatusCode = {
    NUMBER_401: 401
};
const CreateApplication403Error = {
    Forbidden: 'Forbidden'
};
const CreateApplication403StatusCode = {
    NUMBER_403: 403
};
const CreateApplication404Error = {
    Not_Found: 'Not Found'
};
const CreateApplication404StatusCode = {
    NUMBER_404: 404
};
const CreateApplication409Error = {
    Conflict: 'Conflict'
};
const CreateApplication409StatusCode = {
    NUMBER_409: 409
};
const UpdateApplication400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateApplication400StatusCode = {
    NUMBER_400: 400
};
const UpdateApplication401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateApplication401StatusCode = {
    NUMBER_401: 401
};
const UpdateApplication403Error = {
    Forbidden: 'Forbidden'
};
const UpdateApplication403StatusCode = {
    NUMBER_403: 403
};
const UpdateApplication404Error = {
    Not_Found: 'Not Found'
};
const UpdateApplication404StatusCode = {
    NUMBER_404: 404
};
const DeleteApplicationSingular401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteApplicationSingular401StatusCode = {
    NUMBER_401: 401
};
const DeleteApplicationSingular403Error = {
    Forbidden: 'Forbidden'
};
const DeleteApplicationSingular403StatusCode = {
    NUMBER_403: 403
};
const DeleteApplicationSingular404Error = {
    Not_Found: 'Not Found'
};
const DeleteApplicationSingular404StatusCode = {
    NUMBER_404: 404
};
const UpdateApplicationName400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateApplicationName400StatusCode = {
    NUMBER_400: 400
};
const UpdateApplicationName401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateApplicationName401StatusCode = {
    NUMBER_401: 401
};
const UpdateApplicationName403Error = {
    Forbidden: 'Forbidden'
};
const UpdateApplicationName403StatusCode = {
    NUMBER_403: 403
};
const UpdateApplicationName404Error = {
    Not_Found: 'Not Found'
};
const UpdateApplicationName404StatusCode = {
    NUMBER_404: 404
};
const UpdateApplicationName409Error = {
    Conflict: 'Conflict'
};
const UpdateApplicationName409StatusCode = {
    NUMBER_409: 409
};
const GetApplicationAuditLogAuthors401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationAuditLogAuthors401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationAuditLogAuthors403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationAuditLogAuthors403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationAuditLogAuthors404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationAuditLogAuthors404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationAuditLog401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationAuditLog401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationAuditLog403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationAuditLog403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationAuditLog404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationAuditLog404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationVersionListSortOrder = {
    asc: 'asc',
    desc: 'desc'
};
const GetApplicationVersionList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationVersionList401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationVersionList403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationVersionList403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationVersionList404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationVersionList404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationVersionDetail401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationVersionDetail401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationVersionDetail403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationVersionDetail403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationVersionDetail404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationVersionDetail404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationCounters401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationCounters401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationCounters403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationCounters403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationCounters404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationCounters404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationVersionDeployTargetList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationVersionDeployTargetList401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationVersionDeployTargetList403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationVersionDeployTargetList403StatusCode = {
    NUMBER_403: 403
};
const GetDeployApplicationVersionListType = {
    all: 'all',
    environment: 'environment',
    tag: 'tag'
};
const GetDeployApplicationVersionList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetDeployApplicationVersionList401StatusCode = {
    NUMBER_401: 401
};
const GetDeployApplicationVersionList403Error = {
    Forbidden: 'Forbidden'
};
const GetDeployApplicationVersionList403StatusCode = {
    NUMBER_403: 403
};
const DeployApplicationVersion401Error = {
    Unauthorized: 'Unauthorized'
};
const DeployApplicationVersion401StatusCode = {
    NUMBER_401: 401
};
const DeployApplicationVersion403Error = {
    Forbidden: 'Forbidden'
};
const DeployApplicationVersion403StatusCode = {
    NUMBER_403: 403
};
const DeployApplicationVersion404Error = {
    Not_Found: 'Not Found'
};
const DeployApplicationVersion404StatusCode = {
    NUMBER_404: 404
};
const DeployApplicationVersion409Error = {
    Conflict: 'Conflict'
};
const DeployApplicationVersion409StatusCode = {
    NUMBER_409: 409
};
const GetApplicationVersionQueryOpts401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationVersionQueryOpts401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationVersionQueryOpts403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationVersionQueryOpts403StatusCode = {
    NUMBER_403: 403
};
const SetApplicationVersionDeprecated401Error = {
    Unauthorized: 'Unauthorized'
};
const SetApplicationVersionDeprecated401StatusCode = {
    NUMBER_401: 401
};
const SetApplicationVersionDeprecated403Error = {
    Forbidden: 'Forbidden'
};
const SetApplicationVersionDeprecated403StatusCode = {
    NUMBER_403: 403
};
const SetApplicationVersionDeprecated404Error = {
    Not_Found: 'Not Found'
};
const SetApplicationVersionDeprecated404StatusCode = {
    NUMBER_404: 404
};
const SetApplicationVersionUnavailable401Error = {
    Unauthorized: 'Unauthorized'
};
const SetApplicationVersionUnavailable401StatusCode = {
    NUMBER_401: 401
};
const SetApplicationVersionUnavailable403Error = {
    Forbidden: 'Forbidden'
};
const SetApplicationVersionUnavailable403StatusCode = {
    NUMBER_403: 403
};
const SetApplicationVersionUnavailable404Error = {
    Not_Found: 'Not Found'
};
const SetApplicationVersionUnavailable404StatusCode = {
    NUMBER_404: 404
};
const SetApplicationVersionFailed401Error = {
    Unauthorized: 'Unauthorized'
};
const SetApplicationVersionFailed401StatusCode = {
    NUMBER_401: 401
};
const SetApplicationVersionFailed403Error = {
    Forbidden: 'Forbidden'
};
const SetApplicationVersionFailed403StatusCode = {
    NUMBER_403: 403
};
const SetApplicationVersionFailed404Error = {
    Not_Found: 'Not Found'
};
const SetApplicationVersionFailed404StatusCode = {
    NUMBER_404: 404
};
const SetApplicationVersionAvailable401Error = {
    Unauthorized: 'Unauthorized'
};
const SetApplicationVersionAvailable401StatusCode = {
    NUMBER_401: 401
};
const SetApplicationVersionAvailable403Error = {
    Forbidden: 'Forbidden'
};
const SetApplicationVersionAvailable403StatusCode = {
    NUMBER_403: 403
};
const SetApplicationVersionAvailable404Error = {
    Not_Found: 'Not Found'
};
const SetApplicationVersionAvailable404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationGraph401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationGraph401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationGraph403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationGraph403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationGraph404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationGraph404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationGraph409Error = {
    Conflict: 'Conflict'
};
const GetApplicationGraph409StatusCode = {
    NUMBER_409: 409
};
const GetNodeDetails401Error = {
    Unauthorized: 'Unauthorized'
};
const GetNodeDetails401StatusCode = {
    NUMBER_401: 401
};
const GetNodeDetails404Error = {
    Not_Found: 'Not Found'
};
const GetNodeDetails404StatusCode = {
    NUMBER_404: 404
};
const GetNodeDetails409Error = {
    Conflict: 'Conflict'
};
const GetNodeDetails409StatusCode = {
    NUMBER_409: 409
};
const SetApplicationVersionProblematic401Error = {
    Unauthorized: 'Unauthorized'
};
const SetApplicationVersionProblematic401StatusCode = {
    NUMBER_401: 401
};
const SetApplicationVersionProblematic403Error = {
    Forbidden: 'Forbidden'
};
const SetApplicationVersionProblematic403StatusCode = {
    NUMBER_403: 403
};
const SetApplicationVersionProblematic404Error = {
    Not_Found: 'Not Found'
};
const SetApplicationVersionProblematic404StatusCode = {
    NUMBER_404: 404
};
const RemoveApplicationVersionProblematic401Error = {
    Unauthorized: 'Unauthorized'
};
const RemoveApplicationVersionProblematic401StatusCode = {
    NUMBER_401: 401
};
const RemoveApplicationVersionProblematic403Error = {
    Forbidden: 'Forbidden'
};
const RemoveApplicationVersionProblematic403StatusCode = {
    NUMBER_403: 403
};
const RemoveApplicationVersionProblematic404Error = {
    Not_Found: 'Not Found'
};
const RemoveApplicationVersionProblematic404StatusCode = {
    NUMBER_404: 404
};
const CreateApplicationTag401Error = {
    Unauthorized: 'Unauthorized'
};
const CreateApplicationTag401StatusCode = {
    NUMBER_401: 401
};
const CreateApplicationTag403Error = {
    Forbidden: 'Forbidden'
};
const CreateApplicationTag403StatusCode = {
    NUMBER_403: 403
};
const CreateApplicationTag404Error = {
    Not_Found: 'Not Found'
};
const CreateApplicationTag404StatusCode = {
    NUMBER_404: 404
};
const GetTagListSortOrder = {
    asc: 'asc',
    desc: 'desc'
};
const GetTagList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetTagList401StatusCode = {
    NUMBER_401: 401
};
const GetTagList403Error = {
    Forbidden: 'Forbidden'
};
const GetTagList403StatusCode = {
    NUMBER_403: 403
};
const GetTagList404Error = {
    Not_Found: 'Not Found'
};
const GetTagList404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationTag401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationTag401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationTag403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationTag403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationTag404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationTag404StatusCode = {
    NUMBER_404: 404
};
const UpdateApplicationTag401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateApplicationTag401StatusCode = {
    NUMBER_401: 401
};
const UpdateApplicationTag403Error = {
    Forbidden: 'Forbidden'
};
const UpdateApplicationTag403StatusCode = {
    NUMBER_403: 403
};
const UpdateApplicationTag404Error = {
    Not_Found: 'Not Found'
};
const UpdateApplicationTag404StatusCode = {
    NUMBER_404: 404
};
const DeleteApplicationTag401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteApplicationTag401StatusCode = {
    NUMBER_401: 401
};
const DeleteApplicationTag403Error = {
    Forbidden: 'Forbidden'
};
const DeleteApplicationTag403StatusCode = {
    NUMBER_403: 403
};
const DeleteApplicationTag404Error = {
    Not_Found: 'Not Found'
};
const DeleteApplicationTag404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationTagConditionOptions401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationTagConditionOptions401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationTagConditionOptions403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationTagConditionOptions403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationTagConditionOptionsUsers401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationTagConditionOptionsUsers401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationTagConditionOptionsUsers403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationTagConditionOptionsUsers403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationTagConditionOptionsVersions401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationTagConditionOptionsVersions401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationTagConditionOptionsVersions403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationTagConditionOptionsVersions403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationTagConditionVersion401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationTagConditionVersion401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationTagConditionVersion403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationTagConditionVersion403StatusCode = {
    NUMBER_403: 403
};
const RenameApplicationTag401Error = {
    Unauthorized: 'Unauthorized'
};
const RenameApplicationTag401StatusCode = {
    NUMBER_401: 401
};
const RenameApplicationTag403Error = {
    Forbidden: 'Forbidden'
};
const RenameApplicationTag403StatusCode = {
    NUMBER_403: 403
};
const RenameApplicationTag404Error = {
    Not_Found: 'Not Found'
};
const RenameApplicationTag404StatusCode = {
    NUMBER_404: 404
};
const RenameApplicationTag409Error = {
    Not_Found: 'Not Found'
};
const RenameApplicationTag409StatusCode = {
    NUMBER_404: 404
};
const GetApplicationTagQueryOpts401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationTagQueryOpts401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationTagQueryOpts403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationTagQueryOpts403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationTagQueryOpts404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationTagQueryOpts404StatusCode = {
    NUMBER_404: 404
};
const CreateApplicationEnvironmentBodyConditionChannel = {
    tag: 'tag',
    version: 'version'
};
const CreateApplicationEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const CreateApplicationEnvironment401StatusCode = {
    NUMBER_401: 401
};
const CreateApplicationEnvironment403Error = {
    Forbidden: 'Forbidden'
};
const CreateApplicationEnvironment403StatusCode = {
    NUMBER_403: 403
};
const CreateApplicationEnvironment404Error = {
    Not_Found: 'Not Found'
};
const CreateApplicationEnvironment404StatusCode = {
    NUMBER_404: 404
};
const GetEnvironmentListSortBy = {
    name: 'name',
    version: 'version',
    updatedAt: 'updatedAt'
};
const GetEnvironmentListSortOrder = {
    asc: 'asc',
    desc: 'desc'
};
const GetEnvironmentList200EntitiesItemConditionChannel = {
    tag: 'tag',
    version: 'version'
};
const GetEnvironmentList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentList401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentList403Error = {
    Forbidden: 'Forbidden'
};
const GetEnvironmentList403StatusCode = {
    NUMBER_403: 403
};
const GetEnvironmentConditionOptions401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentConditionOptions401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentConditionOptions403Error = {
    Forbidden: 'Forbidden'
};
const GetEnvironmentConditionOptions403StatusCode = {
    NUMBER_403: 403
};
const GetEnvironmentConditionVersionChannel = {
    tag: 'tag',
    version: 'version'
};
const GetEnvironmentConditionVersion401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentConditionVersion401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentConditionVersion403Error = {
    Forbidden: 'Forbidden'
};
const GetEnvironmentConditionVersion403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationEnvironment200ValueConditionChannel = {
    tag: 'tag',
    version: 'version'
};
const GetApplicationEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationEnvironment401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationEnvironment403Error = {
    Forbidden: 'Forbidden'
};
const GetApplicationEnvironment403StatusCode = {
    NUMBER_403: 403
};
const GetApplicationEnvironment404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationEnvironment404StatusCode = {
    NUMBER_404: 404
};
const UpdateApplicationEnvironmentBodyConditionChannel = {
    tag: 'tag',
    version: 'version'
};
const UpdateApplicationEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateApplicationEnvironment401StatusCode = {
    NUMBER_401: 401
};
const UpdateApplicationEnvironment403Error = {
    Forbidden: 'Forbidden'
};
const UpdateApplicationEnvironment403StatusCode = {
    NUMBER_403: 403
};
const UpdateApplicationEnvironment404Error = {
    Not_Found: 'Not Found'
};
const UpdateApplicationEnvironment404StatusCode = {
    NUMBER_404: 404
};
const DeleteApplicationEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteApplicationEnvironment401StatusCode = {
    NUMBER_401: 401
};
const DeleteApplicationEnvironment403Error = {
    Forbidden: 'Forbidden'
};
const DeleteApplicationEnvironment403StatusCode = {
    NUMBER_403: 403
};
const DeleteApplicationEnvironment404Error = {
    Not_Found: 'Not Found'
};
const DeleteApplicationEnvironment404StatusCode = {
    NUMBER_404: 404
};
const RenameApplicationEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const RenameApplicationEnvironment401StatusCode = {
    NUMBER_401: 401
};
const RenameApplicationEnvironment403Error = {
    Forbidden: 'Forbidden'
};
const RenameApplicationEnvironment403StatusCode = {
    NUMBER_403: 403
};
const RenameApplicationEnvironment404Error = {
    Not_Found: 'Not Found'
};
const RenameApplicationEnvironment404StatusCode = {
    NUMBER_404: 404
};
const RenameApplicationEnvironment409Error = {
    Not_Found: 'Not Found'
};
const RenameApplicationEnvironment409StatusCode = {
    NUMBER_404: 404
};
const AddEnvironmentCustomDomain401Error = {
    Unauthorized: 'Unauthorized'
};
const AddEnvironmentCustomDomain401StatusCode = {
    NUMBER_401: 401
};
const AddEnvironmentCustomDomain403Error = {
    Forbidden: 'Forbidden'
};
const AddEnvironmentCustomDomain403StatusCode = {
    NUMBER_403: 403
};
const AddEnvironmentCustomDomain404Error = {
    Not_Found: 'Not Found'
};
const AddEnvironmentCustomDomain404StatusCode = {
    NUMBER_404: 404
};
const RemoveEnvironmentCustomDomain401Error = {
    Unauthorized: 'Unauthorized'
};
const RemoveEnvironmentCustomDomain401StatusCode = {
    NUMBER_401: 401
};
const RemoveEnvironmentCustomDomain403Error = {
    Forbidden: 'Forbidden'
};
const RemoveEnvironmentCustomDomain403StatusCode = {
    NUMBER_403: 403
};
const RemoveEnvironmentCustomDomain404Error = {
    Not_Found: 'Not Found'
};
const RemoveEnvironmentCustomDomain404StatusCode = {
    NUMBER_404: 404
};
const UpdateEnvironmentEnvVarSet401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateEnvironmentEnvVarSet401StatusCode = {
    NUMBER_401: 401
};
const UpdateEnvironmentEnvVarSet403Error = {
    Forbidden: 'Forbidden'
};
const UpdateEnvironmentEnvVarSet403StatusCode = {
    NUMBER_403: 403
};
const UpdateEnvironmentEnvVarSet404Error = {
    Not_Found: 'Not Found'
};
const UpdateEnvironmentEnvVarSet404StatusCode = {
    NUMBER_404: 404
};
const GetEnvironmentEnvVarSet401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentEnvVarSet401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentEnvVarSet403Error = {
    Forbidden: 'Forbidden'
};
const GetEnvironmentEnvVarSet403StatusCode = {
    NUMBER_403: 403
};
const GetEnvironmentEnvVarSet404Error = {
    Not_Found: 'Not Found'
};
const GetEnvironmentEnvVarSet404StatusCode = {
    NUMBER_404: 404
};
const ValidateEnvVarPromotion401Error = {
    Unauthorized: 'Unauthorized'
};
const ValidateEnvVarPromotion401StatusCode = {
    NUMBER_401: 401
};
const ValidateEnvVarPromotion403Error = {
    Forbidden: 'Forbidden'
};
const ValidateEnvVarPromotion403StatusCode = {
    NUMBER_403: 403
};
const ValidateEnvVarPromotion404Error = {
    Not_Found: 'Not Found'
};
const ValidateEnvVarPromotion404StatusCode = {
    NUMBER_404: 404
};
const GetEnvironmentDependencies401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentDependencies401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentDependencies403Error = {
    Forbidden: 'Forbidden'
};
const GetEnvironmentDependencies403StatusCode = {
    NUMBER_403: 403
};
const GetEnvironmentDependencies404Error = {
    Not_Found: 'Not Found'
};
const GetEnvironmentDependencies404StatusCode = {
    NUMBER_404: 404
};
const UpdateEnvironmentDependencies401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateEnvironmentDependencies401StatusCode = {
    NUMBER_401: 401
};
const UpdateEnvironmentDependencies403Error = {
    Forbidden: 'Forbidden'
};
const UpdateEnvironmentDependencies403StatusCode = {
    NUMBER_403: 403
};
const UpdateEnvironmentDependencies404Error = {
    Not_Found: 'Not Found'
};
const UpdateEnvironmentDependencies404StatusCode = {
    NUMBER_404: 404
};
const AddEnvironmentMembers401Error = {
    Unauthorized: 'Unauthorized'
};
const AddEnvironmentMembers401StatusCode = {
    NUMBER_401: 401
};
const AddEnvironmentMembers403Error = {
    Forbidden: 'Forbidden'
};
const AddEnvironmentMembers403StatusCode = {
    NUMBER_403: 403
};
const AddEnvironmentMembers404Error = {
    Not_Found: 'Not Found'
};
const AddEnvironmentMembers404StatusCode = {
    NUMBER_404: 404
};
const GetEnvironmentMembers401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentMembers401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentMembers403Error = {
    Forbidden: 'Forbidden'
};
const GetEnvironmentMembers403StatusCode = {
    NUMBER_403: 403
};
const GetEnvironmentMembers404Error = {
    Not_Found: 'Not Found'
};
const GetEnvironmentMembers404StatusCode = {
    NUMBER_404: 404
};
const GetAddEnvironmentMemberOptions401Error = {
    Unauthorized: 'Unauthorized'
};
const GetAddEnvironmentMemberOptions401StatusCode = {
    NUMBER_401: 401
};
const GetAddEnvironmentMemberOptions403Error = {
    Forbidden: 'Forbidden'
};
const GetAddEnvironmentMemberOptions403StatusCode = {
    NUMBER_403: 403
};
const GetAddEnvironmentMemberOptions404Error = {
    Not_Found: 'Not Found'
};
const GetAddEnvironmentMemberOptions404StatusCode = {
    NUMBER_404: 404
};
const RemoveEnvironmentMember401Error = {
    Unauthorized: 'Unauthorized'
};
const RemoveEnvironmentMember401StatusCode = {
    NUMBER_401: 401
};
const RemoveEnvironmentMember403Error = {
    Forbidden: 'Forbidden'
};
const RemoveEnvironmentMember403StatusCode = {
    NUMBER_403: 403
};
const RemoveEnvironmentMember404Error = {
    Not_Found: 'Not Found'
};
const RemoveEnvironmentMember404StatusCode = {
    NUMBER_404: 404
};
const ListOrganizations401Error = {
    Unauthorized: 'Unauthorized'
};
const ListOrganizations401StatusCode = {
    NUMBER_401: 401
};
const CreateOrganization400Error = {
    Bad_Request: 'Bad Request'
};
const CreateOrganization400StatusCode = {
    NUMBER_400: 400
};
const CreateOrganization401Error = {
    Unauthorized: 'Unauthorized'
};
const CreateOrganization401StatusCode = {
    NUMBER_401: 401
};
const CreateOrganization409Error = {
    Conflict: 'Conflict'
};
const CreateOrganization409StatusCode = {
    NUMBER_409: 409
};
const GetOrganization401Error = {
    Unauthorized: 'Unauthorized'
};
const GetOrganization401StatusCode = {
    NUMBER_401: 401
};
const GetOrganization403Error = {
    Forbidden: 'Forbidden'
};
const GetOrganization403StatusCode = {
    NUMBER_403: 403
};
const GetOrganization404Error = {
    Not_Found: 'Not Found'
};
const GetOrganization404StatusCode = {
    NUMBER_404: 404
};
const DeleteOrganization401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteOrganization401StatusCode = {
    NUMBER_401: 401
};
const DeleteOrganization403Error = {
    Forbidden: 'Forbidden'
};
const DeleteOrganization403StatusCode = {
    NUMBER_403: 403
};
const DeleteOrganization404Error = {
    Not_Found: 'Not Found'
};
const DeleteOrganization404StatusCode = {
    NUMBER_404: 404
};
const UpdateOrganizationSettings400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateOrganizationSettings400StatusCode = {
    NUMBER_400: 400
};
const UpdateOrganizationSettings401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateOrganizationSettings401StatusCode = {
    NUMBER_401: 401
};
const UpdateOrganizationSettings403Error = {
    Forbidden: 'Forbidden'
};
const UpdateOrganizationSettings403StatusCode = {
    NUMBER_403: 403
};
const UpdateOrganizationSettings404Error = {
    Not_Found: 'Not Found'
};
const UpdateOrganizationSettings404StatusCode = {
    NUMBER_404: 404
};
const GetOrganizationMembershipDomains401Error = {
    Unauthorized: 'Unauthorized'
};
const GetOrganizationMembershipDomains401StatusCode = {
    NUMBER_401: 401
};
const GetOrganizationMembershipDomains403Error = {
    Forbidden: 'Forbidden'
};
const GetOrganizationMembershipDomains403StatusCode = {
    NUMBER_403: 403
};
const GetOrganizationMembershipDomains404Error = {
    Not_Found: 'Not Found'
};
const GetOrganizationMembershipDomains404StatusCode = {
    NUMBER_404: 404
};
const UpsertOrganizationMembershipDomain400Error = {
    Bad_Request: 'Bad Request'
};
const UpsertOrganizationMembershipDomain400StatusCode = {
    NUMBER_400: 400
};
const UpsertOrganizationMembershipDomain401Error = {
    Unauthorized: 'Unauthorized'
};
const UpsertOrganizationMembershipDomain401StatusCode = {
    NUMBER_401: 401
};
const UpsertOrganizationMembershipDomain403Error = {
    Forbidden: 'Forbidden'
};
const UpsertOrganizationMembershipDomain403StatusCode = {
    NUMBER_403: 403
};
const UpsertOrganizationMembershipDomain404Error = {
    Not_Found: 'Not Found'
};
const UpsertOrganizationMembershipDomain404StatusCode = {
    NUMBER_404: 404
};
const SendOrganizationMembershipDomainCode400Error = {
    Bad_Request: 'Bad Request'
};
const SendOrganizationMembershipDomainCode400StatusCode = {
    NUMBER_400: 400
};
const SendOrganizationMembershipDomainCode401Error = {
    Unauthorized: 'Unauthorized'
};
const SendOrganizationMembershipDomainCode401StatusCode = {
    NUMBER_401: 401
};
const SendOrganizationMembershipDomainCode403Error = {
    Forbidden: 'Forbidden'
};
const SendOrganizationMembershipDomainCode403StatusCode = {
    NUMBER_403: 403
};
const SendOrganizationMembershipDomainCode404Error = {
    Not_Found: 'Not Found'
};
const SendOrganizationMembershipDomainCode404StatusCode = {
    NUMBER_404: 404
};
const SendOrganizationMembershipDomainCode429Error = {
    Too_Many_Requests: 'Too Many Requests'
};
const SendOrganizationMembershipDomainCode429StatusCode = {
    NUMBER_429: 429
};
const VerifyOrganizationMembershipDomain400Error = {
    Bad_Request: 'Bad Request'
};
const VerifyOrganizationMembershipDomain400StatusCode = {
    NUMBER_400: 400
};
const VerifyOrganizationMembershipDomain401Error = {
    Unauthorized: 'Unauthorized'
};
const VerifyOrganizationMembershipDomain401StatusCode = {
    NUMBER_401: 401
};
const VerifyOrganizationMembershipDomain403Error = {
    Forbidden: 'Forbidden'
};
const VerifyOrganizationMembershipDomain403StatusCode = {
    NUMBER_403: 403
};
const VerifyOrganizationMembershipDomain404Error = {
    Not_Found: 'Not Found'
};
const VerifyOrganizationMembershipDomain404StatusCode = {
    NUMBER_404: 404
};
const DeleteOrganizationMembershipDomain401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteOrganizationMembershipDomain401StatusCode = {
    NUMBER_401: 401
};
const DeleteOrganizationMembershipDomain403Error = {
    Forbidden: 'Forbidden'
};
const DeleteOrganizationMembershipDomain403StatusCode = {
    NUMBER_403: 403
};
const DeleteOrganizationMembershipDomain404Error = {
    Not_Found: 'Not Found'
};
const DeleteOrganizationMembershipDomain404StatusCode = {
    NUMBER_404: 404
};
const ListOrganizationMembers401Error = {
    Unauthorized: 'Unauthorized'
};
const ListOrganizationMembers401StatusCode = {
    NUMBER_401: 401
};
const ListOrganizationMembers403Error = {
    Forbidden: 'Forbidden'
};
const ListOrganizationMembers403StatusCode = {
    NUMBER_403: 403
};
const ListOrganizationMembers404Error = {
    Not_Found: 'Not Found'
};
const ListOrganizationMembers404StatusCode = {
    NUMBER_404: 404
};
const UpdateOrganization400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateOrganization400StatusCode = {
    NUMBER_400: 400
};
const UpdateOrganization401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateOrganization401StatusCode = {
    NUMBER_401: 401
};
const UpdateOrganization403Error = {
    Forbidden: 'Forbidden'
};
const UpdateOrganization403StatusCode = {
    NUMBER_403: 403
};
const UpdateOrganization404Error = {
    Not_Found: 'Not Found'
};
const UpdateOrganization404StatusCode = {
    NUMBER_404: 404
};
const UpdateOrganization409Error = {
    Conflict: 'Conflict'
};
const UpdateOrganization409StatusCode = {
    NUMBER_409: 409
};
const GetUniqueOrganizationName401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUniqueOrganizationName401StatusCode = {
    NUMBER_401: 401
};
const IsUniqueOrganizationName401Error = {
    Unauthorized: 'Unauthorized'
};
const IsUniqueOrganizationName401StatusCode = {
    NUMBER_401: 401
};
const SearchOrganizations401Error = {
    Unauthorized: 'Unauthorized'
};
const SearchOrganizations401StatusCode = {
    NUMBER_401: 401
};
const UpdateOrganizationName400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateOrganizationName400StatusCode = {
    NUMBER_400: 400
};
const UpdateOrganizationName401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateOrganizationName401StatusCode = {
    NUMBER_401: 401
};
const UpdateOrganizationName403Error = {
    Forbidden: 'Forbidden'
};
const UpdateOrganizationName403StatusCode = {
    NUMBER_403: 403
};
const UpdateOrganizationName404Error = {
    Not_Found: 'Not Found'
};
const UpdateOrganizationName404StatusCode = {
    NUMBER_404: 404
};
const UpdateOrganizationName409Error = {
    Conflict: 'Conflict'
};
const UpdateOrganizationName409StatusCode = {
    NUMBER_409: 409
};
const GetOrganizationCounters401Error = {
    Unauthorized: 'Unauthorized'
};
const GetOrganizationCounters401StatusCode = {
    NUMBER_401: 401
};
const GetOrganizationCounters403Error = {
    Forbidden: 'Forbidden'
};
const GetOrganizationCounters403StatusCode = {
    NUMBER_403: 403
};
const GetOrganizationCounters404Error = {
    Not_Found: 'Not Found'
};
const GetOrganizationCounters404StatusCode = {
    NUMBER_404: 404
};
const GetOrganizationApplicationListType = {
    all: 'all',
    created_by_me: 'created_by_me',
    public: 'public',
    private: 'private',
    removed: 'removed'
};
const GetOrganizationApplicationListSort = {
    name_asc: 'name_asc',
    name_desc: 'name_desc',
    latest_updates: 'latest_updates'
};
const GetOrganizationApplicationList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetOrganizationApplicationList401StatusCode = {
    NUMBER_401: 401
};
const GetOrganizationApplicationList403Error = {
    Forbidden: 'Forbidden'
};
const GetOrganizationApplicationList403StatusCode = {
    NUMBER_403: 403
};
const GetOrganizationApplicationList404Error = {
    Not_Found: 'Not Found'
};
const GetOrganizationApplicationList404StatusCode = {
    NUMBER_404: 404
};
const ProjectListType = {
    all: 'all',
    created_by_me: 'created_by_me',
    public: 'public',
    private: 'private',
    removed: 'removed'
};
const ProjectListSort = {
    name_asc: 'name_asc',
    name_desc: 'name_desc',
    latest_updates: 'latest_updates'
};
const ProjectList200EntitiesItemVisibility = {
    public: 'public',
    private: 'private'
};
const ProjectList401Error = {
    Unauthorized: 'Unauthorized'
};
const ProjectList401StatusCode = {
    NUMBER_401: 401
};
const ProjectList403Error = {
    Forbidden: 'Forbidden'
};
const ProjectList403StatusCode = {
    NUMBER_403: 403
};
const ProjectList404Error = {
    Not_Found: 'Not Found'
};
const ProjectList404StatusCode = {
    NUMBER_404: 404
};
const SideBarProjectList401Error = {
    Unauthorized: 'Unauthorized'
};
const SideBarProjectList401StatusCode = {
    NUMBER_401: 401
};
const SideBarProjectList403Error = {
    Forbidden: 'Forbidden'
};
const SideBarProjectList403StatusCode = {
    NUMBER_403: 403
};
const SideBarProjectList404Error = {
    Not_Found: 'Not Found'
};
const SideBarProjectList404StatusCode = {
    NUMBER_404: 404
};
const GetProjectSidebarSearch401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectSidebarSearch401StatusCode = {
    NUMBER_401: 401
};
const GetProjectSidebarSearch403Error = {
    Forbidden: 'Forbidden'
};
const GetProjectSidebarSearch403StatusCode = {
    NUMBER_403: 403
};
const ListOrganizationProjects401Error = {
    Unauthorized: 'Unauthorized'
};
const ListOrganizationProjects401StatusCode = {
    NUMBER_401: 401
};
const ListOrganizationProjects403Error = {
    Forbidden: 'Forbidden'
};
const ListOrganizationProjects403StatusCode = {
    NUMBER_403: 403
};
const CreateProjectBodyVisibility = {
    public: 'public',
    private: 'private'
};
const CreateProject201ValueRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const CreateProject201ValueVisibility = {
    public: 'public',
    private: 'private'
};
const CreateProject401Error = {
    Unauthorized: 'Unauthorized'
};
const CreateProject401StatusCode = {
    NUMBER_401: 401
};
const CreateProject403Error = {
    Forbidden: 'Forbidden'
};
const CreateProject403StatusCode = {
    NUMBER_403: 403
};
const CreateProject409Error = {
    Conflict: 'Conflict'
};
const CreateProject409StatusCode = {
    NUMBER_409: 409
};
const GetProjectIncludeItem = {
    applications: 'applications',
    contributors: 'contributors'
};
const GetProject200ValueRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const GetProject200ValueVisibility = {
    public: 'public',
    private: 'private'
};
const GetProject401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProject401StatusCode = {
    NUMBER_401: 401
};
const GetProject403Error = {
    Forbidden: 'Forbidden'
};
const GetProject403StatusCode = {
    NUMBER_403: 403
};
const GetProject404Error = {
    Not_Found: 'Not Found'
};
const GetProject404StatusCode = {
    NUMBER_404: 404
};
const DeleteProject401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteProject401StatusCode = {
    NUMBER_401: 401
};
const DeleteProject403Error = {
    Forbidden: 'Forbidden'
};
const DeleteProject403StatusCode = {
    NUMBER_403: 403
};
const DeleteProject404Error = {
    Not_Found: 'Not Found'
};
const DeleteProject404StatusCode = {
    NUMBER_404: 404
};
const GetProjectSettings401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectSettings401StatusCode = {
    NUMBER_401: 401
};
const GetProjectSettings403Error = {
    Forbidden: 'Forbidden'
};
const GetProjectSettings403StatusCode = {
    NUMBER_403: 403
};
const GetProjectSettings404Error = {
    Not_Found: 'Not Found'
};
const GetProjectSettings404StatusCode = {
    NUMBER_404: 404
};
const UpdateProjectSettings401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateProjectSettings401StatusCode = {
    NUMBER_401: 401
};
const UpdateProjectSettings403Error = {
    Forbidden: 'Forbidden'
};
const UpdateProjectSettings403StatusCode = {
    NUMBER_403: 403
};
const UpdateProjectSettings404Error = {
    Not_Found: 'Not Found'
};
const UpdateProjectSettings404StatusCode = {
    NUMBER_404: 404
};
const ListProjectContributors401Error = {
    Unauthorized: 'Unauthorized'
};
const ListProjectContributors401StatusCode = {
    NUMBER_401: 401
};
const ListProjectContributors403Error = {
    Forbidden: 'Forbidden'
};
const ListProjectContributors403StatusCode = {
    NUMBER_403: 403
};
const ListProjectContributors404Error = {
    Not_Found: 'Not Found'
};
const ListProjectContributors404StatusCode = {
    NUMBER_404: 404
};
const ListProjectContributorsList401Error = {
    Unauthorized: 'Unauthorized'
};
const ListProjectContributorsList401StatusCode = {
    NUMBER_401: 401
};
const ListProjectContributorsList403Error = {
    Forbidden: 'Forbidden'
};
const ListProjectContributorsList403StatusCode = {
    NUMBER_403: 403
};
const ListProjectContributorsList404Error = {
    Not_Found: 'Not Found'
};
const ListProjectContributorsList404StatusCode = {
    NUMBER_404: 404
};
const GetUniqueProjectName401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUniqueProjectName401StatusCode = {
    NUMBER_401: 401
};
const GetProjectSummary200ValueVisibility = {
    public: 'public',
    private: 'private'
};
const GetProjectSummary401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectSummary401StatusCode = {
    NUMBER_401: 401
};
const GetProjectSummary403Error = {
    Forbidden: 'Forbidden'
};
const GetProjectSummary403StatusCode = {
    NUMBER_403: 403
};
const GetProjectSummary404Error = {
    Not_Found: 'Not Found'
};
const GetProjectSummary404StatusCode = {
    NUMBER_404: 404
};
const GetProjectApplicationList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectApplicationList401StatusCode = {
    NUMBER_401: 401
};
const GetProjectApplicationList403Error = {
    Forbidden: 'Forbidden'
};
const GetProjectApplicationList403StatusCode = {
    NUMBER_403: 403
};
const GetProjectApplicationList404Error = {
    Not_Found: 'Not Found'
};
const GetProjectApplicationList404StatusCode = {
    NUMBER_404: 404
};
const UpdateProjectName401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateProjectName401StatusCode = {
    NUMBER_401: 401
};
const UpdateProjectName403Error = {
    Forbidden: 'Forbidden'
};
const UpdateProjectName403StatusCode = {
    NUMBER_403: 403
};
const UpdateProjectName404Error = {
    Not_Found: 'Not Found'
};
const UpdateProjectName404StatusCode = {
    NUMBER_404: 404
};
const UpdateProjectName409Error = {
    Conflict: 'Conflict'
};
const UpdateProjectName409StatusCode = {
    NUMBER_409: 409
};
const UpdateProjectById200ValueRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const UpdateProjectById200ValueVisibility = {
    public: 'public',
    private: 'private'
};
const UpdateProjectById401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateProjectById401StatusCode = {
    NUMBER_401: 401
};
const UpdateProjectById403Error = {
    Forbidden: 'Forbidden'
};
const UpdateProjectById403StatusCode = {
    NUMBER_403: 403
};
const UpdateProjectById404Error = {
    Not_Found: 'Not Found'
};
const UpdateProjectById404StatusCode = {
    NUMBER_404: 404
};
const UpdateProjectById409Error = {
    Conflict: 'Conflict'
};
const UpdateProjectById409StatusCode = {
    NUMBER_409: 409
};
const DeleteProjectById200ValueRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const DeleteProjectById200ValueVisibility = {
    public: 'public',
    private: 'private'
};
const DeleteProjectById401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteProjectById401StatusCode = {
    NUMBER_401: 401
};
const DeleteProjectById403Error = {
    Forbidden: 'Forbidden'
};
const DeleteProjectById403StatusCode = {
    NUMBER_403: 403
};
const DeleteProjectById404Error = {
    Not_Found: 'Not Found'
};
const DeleteProjectById404StatusCode = {
    NUMBER_404: 404
};
const RestoreProject200ValueRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const RestoreProject200ValueVisibility = {
    public: 'public',
    private: 'private'
};
const RestoreProject401Error = {
    Unauthorized: 'Unauthorized'
};
const RestoreProject401StatusCode = {
    NUMBER_401: 401
};
const RestoreProject403Error = {
    Forbidden: 'Forbidden'
};
const RestoreProject403StatusCode = {
    NUMBER_403: 403
};
const RestoreProject404Error = {
    Not_Found: 'Not Found'
};
const RestoreProject404StatusCode = {
    NUMBER_404: 404
};
const RestoreProject409Error = {
    Conflict: 'Conflict'
};
const RestoreProject409StatusCode = {
    NUMBER_409: 409
};
const AddProjectContributors401Error = {
    Unauthorized: 'Unauthorized'
};
const AddProjectContributors401StatusCode = {
    NUMBER_401: 401
};
const AddProjectContributors403Error = {
    Forbidden: 'Forbidden'
};
const AddProjectContributors403StatusCode = {
    NUMBER_403: 403
};
const AddProjectContributors409Error = {
    Conflict: 'Conflict'
};
const AddProjectContributors409StatusCode = {
    NUMBER_409: 409
};
const UpdateProjectContributorRole200ValueRole = {
    viewer: 'viewer',
    editor: 'editor',
    admin: 'admin',
    owner: 'owner'
};
const UpdateProjectContributorRole401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateProjectContributorRole401StatusCode = {
    NUMBER_401: 401
};
const UpdateProjectContributorRole403Error = {
    Forbidden: 'Forbidden'
};
const UpdateProjectContributorRole403StatusCode = {
    NUMBER_403: 403
};
const UpdateProjectContributorRole404Error = {
    Not_Found: 'Not Found'
};
const UpdateProjectContributorRole404StatusCode = {
    NUMBER_404: 404
};
const RemoveProjectTeam401Error = {
    Unauthorized: 'Unauthorized'
};
const RemoveProjectTeam401StatusCode = {
    NUMBER_401: 401
};
const RemoveProjectTeam403Error = {
    Forbidden: 'Forbidden'
};
const RemoveProjectTeam403StatusCode = {
    NUMBER_403: 403
};
const RemoveProjectTeam404Error = {
    Not_Found: 'Not Found'
};
const RemoveProjectTeam404StatusCode = {
    NUMBER_404: 404
};
const RemoveProjectMember401Error = {
    Unauthorized: 'Unauthorized'
};
const RemoveProjectMember401StatusCode = {
    NUMBER_401: 401
};
const RemoveProjectMember403Error = {
    Forbidden: 'Forbidden'
};
const RemoveProjectMember403StatusCode = {
    NUMBER_403: 403
};
const RemoveProjectMember404Error = {
    Not_Found: 'Not Found'
};
const RemoveProjectMember404StatusCode = {
    NUMBER_404: 404
};
const GetProjectAuditLog401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectAuditLog401StatusCode = {
    NUMBER_401: 401
};
const GetProjectAuditLog403Error = {
    Forbidden: 'Forbidden'
};
const GetProjectAuditLog403StatusCode = {
    NUMBER_403: 403
};
const GetProjectAuditLog404Error = {
    Not_Found: 'Not Found'
};
const GetProjectAuditLog404StatusCode = {
    NUMBER_404: 404
};
const GetProjectAuditLogAuthors401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectAuditLogAuthors401StatusCode = {
    NUMBER_401: 401
};
const GetProjectAuditLogAuthors403Error = {
    Forbidden: 'Forbidden'
};
const GetProjectAuditLogAuthors403StatusCode = {
    NUMBER_403: 403
};
const GetProjectAuditLogAuthors404Error = {
    Not_Found: 'Not Found'
};
const GetProjectAuditLogAuthors404StatusCode = {
    NUMBER_404: 404
};
const GetCurrentUserProfile401Error = {
    Unauthorized: 'Unauthorized'
};
const GetCurrentUserProfile401StatusCode = {
    NUMBER_401: 401
};
const GetCurrentUserProfile404Error = {
    Not_Found: 'Not Found'
};
const GetCurrentUserProfile404StatusCode = {
    NUMBER_404: 404
};
const UpdateCurrentUserProfile400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateCurrentUserProfile400StatusCode = {
    NUMBER_400: 400
};
const UpdateCurrentUserProfile401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateCurrentUserProfile401StatusCode = {
    NUMBER_401: 401
};
const UpdateCurrentUserProfile404Error = {
    Not_Found: 'Not Found'
};
const UpdateCurrentUserProfile404StatusCode = {
    NUMBER_404: 404
};
const UpdateUser400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateUser400StatusCode = {
    NUMBER_400: 400
};
const UpdateUser401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateUser401StatusCode = {
    NUMBER_401: 401
};
const UpdateUser404Error = {
    Not_Found: 'Not Found'
};
const UpdateUser404StatusCode = {
    NUMBER_404: 404
};
const DeactivateCurrentUser400Error = {
    Bad_Request: 'Bad Request'
};
const DeactivateCurrentUser400StatusCode = {
    NUMBER_400: 400
};
const DeactivateCurrentUser401Error = {
    Unauthorized: 'Unauthorized'
};
const DeactivateCurrentUser401StatusCode = {
    NUMBER_401: 401
};
const GetUserOrganizations401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserOrganizations401StatusCode = {
    NUMBER_401: 401
};
const GetUserPins401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserPins401StatusCode = {
    NUMBER_401: 401
};
const GetUserPins404Error = {
    Not_Found: 'Not Found'
};
const GetUserPins404StatusCode = {
    NUMBER_404: 404
};
const UpdateUserPins400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateUserPins400StatusCode = {
    NUMBER_400: 400
};
const UpdateUserPins401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateUserPins401StatusCode = {
    NUMBER_401: 401
};
const GetCurrentUser401Error = {
    Unauthorized: 'Unauthorized'
};
const GetCurrentUser401StatusCode = {
    NUMBER_401: 401
};
const GetCurrentUser404Error = {
    Not_Found: 'Not Found'
};
const GetCurrentUser404StatusCode = {
    NUMBER_404: 404
};
const GetCurrentUserOrganizationList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetCurrentUserOrganizationList401StatusCode = {
    NUMBER_401: 401
};
const GetUserOrganizationListByEmail401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserOrganizationListByEmail401StatusCode = {
    NUMBER_401: 401
};
const GetUserOrganizationListByEmail404Error = {
    Not_Found: 'Not Found'
};
const GetUserOrganizationListByEmail404StatusCode = {
    NUMBER_404: 404
};
const GetUserProjectListByEmailType = {
    all: 'all',
    created_by_me: 'created_by_me',
    public: 'public',
    private: 'private',
    removed: 'removed'
};
const GetUserProjectListByEmailSort = {
    name_asc: 'name_asc',
    name_desc: 'name_desc',
    latest_updates: 'latest_updates'
};
const GetUserProjectListByEmail401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserProjectListByEmail401StatusCode = {
    NUMBER_401: 401
};
const GetUserProjectListByEmail404Error = {
    Not_Found: 'Not Found'
};
const GetUserProjectListByEmail404StatusCode = {
    NUMBER_404: 404
};
const GetUserApplicationListByEmailType = {
    all: 'all',
    created_by_me: 'created_by_me',
    public: 'public',
    private: 'private',
    removed: 'removed'
};
const GetUserApplicationListByEmailSort = {
    name_asc: 'name_asc',
    name_desc: 'name_desc',
    latest_updates: 'latest_updates'
};
const GetUserApplicationListByEmail401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserApplicationListByEmail401StatusCode = {
    NUMBER_401: 401
};
const GetUserApplicationListByEmail404Error = {
    Not_Found: 'Not Found'
};
const GetUserApplicationListByEmail404StatusCode = {
    NUMBER_404: 404
};
const IsUniqueUsername401Error = {
    Unauthorized: 'Unauthorized'
};
const IsUniqueUsername401StatusCode = {
    NUMBER_401: 401
};
const GetUserByUsername401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserByUsername401StatusCode = {
    NUMBER_401: 401
};
const UpsertUser400Error = {
    Bad_Request: 'Bad Request'
};
const UpsertUser400StatusCode = {
    NUMBER_400: 400
};
const UpsertUser401Error = {
    Unauthorized: 'Unauthorized'
};
const UpsertUser401StatusCode = {
    NUMBER_401: 401
};
const GetAccountsAssociated401Error = {
    Unauthorized: 'Unauthorized'
};
const GetAccountsAssociated401StatusCode = {
    NUMBER_401: 401
};
const SetPrimaryAccount400Error = {
    Bad_Request: 'Bad Request'
};
const SetPrimaryAccount400StatusCode = {
    NUMBER_400: 400
};
const SetPrimaryAccount401Error = {
    Unauthorized: 'Unauthorized'
};
const SetPrimaryAccount401StatusCode = {
    NUMBER_401: 401
};
const SetPrimaryAccount404Error = {
    Not_Found: 'Not Found'
};
const SetPrimaryAccount404StatusCode = {
    NUMBER_404: 404
};
const GetUserPinOptions401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserPinOptions401StatusCode = {
    NUMBER_401: 401
};
const GetBuildVersionListSortOrder = {
    asc: 'asc',
    desc: 'desc'
};
const GetBuildVersionList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetBuildVersionList401StatusCode = {
    NUMBER_401: 401
};
const GetBuildVersionList403Error = {
    Forbidden: 'Forbidden'
};
const GetBuildVersionList403StatusCode = {
    NUMBER_403: 403
};
const GetBuildVersionList404Error = {
    Not_Found: 'Not Found'
};
const GetBuildVersionList404StatusCode = {
    NUMBER_404: 404
};
const GetBuildVersionDetail401Error = {
    Unauthorized: 'Unauthorized'
};
const GetBuildVersionDetail401StatusCode = {
    NUMBER_401: 401
};
const GetBuildVersionDetail403Error = {
    Forbidden: 'Forbidden'
};
const GetBuildVersionDetail403StatusCode = {
    NUMBER_403: 403
};
const GetBuildVersionDetail404Error = {
    Not_Found: 'Not Found'
};
const GetBuildVersionDetail404StatusCode = {
    NUMBER_404: 404
};
const GetDeployTargets401Error = {
    Unauthorized: 'Unauthorized'
};
const GetDeployTargets401StatusCode = {
    NUMBER_401: 401
};
const GetDeployTargets403Error = {
    Forbidden: 'Forbidden'
};
const GetDeployTargets403StatusCode = {
    NUMBER_403: 403
};
const GetDeployTargets404Error = {
    Not_Found: 'Not Found'
};
const GetDeployTargets404StatusCode = {
    NUMBER_404: 404
};
const GetDeployedVersionsType = {
    all: 'all',
    environment: 'environment',
    tag: 'tag'
};
const GetDeployedVersions401Error = {
    Unauthorized: 'Unauthorized'
};
const GetDeployedVersions401StatusCode = {
    NUMBER_401: 401
};
const GetDeployedVersions403Error = {
    Forbidden: 'Forbidden'
};
const GetDeployedVersions403StatusCode = {
    NUMBER_403: 403
};
const GetDeployedVersions404Error = {
    Not_Found: 'Not Found'
};
const GetDeployedVersions404StatusCode = {
    NUMBER_404: 404
};
const DeployVersion400Error = {
    Bad_Request: 'Bad Request'
};
const DeployVersion400StatusCode = {
    NUMBER_400: 400
};
const DeployVersion401Error = {
    Unauthorized: 'Unauthorized'
};
const DeployVersion401StatusCode = {
    NUMBER_401: 401
};
const DeployVersion403Error = {
    Forbidden: 'Forbidden'
};
const DeployVersion403StatusCode = {
    NUMBER_403: 403
};
const DeployVersion404Error = {
    Not_Found: 'Not Found'
};
const DeployVersion404StatusCode = {
    NUMBER_404: 404
};
const CheckDevopsFeature401Error = {
    Unauthorized: 'Unauthorized'
};
const CheckDevopsFeature401StatusCode = {
    NUMBER_401: 401
};
const GetReleasePipelineByOrgList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetReleasePipelineByOrgList401StatusCode = {
    NUMBER_401: 401
};
const GetReleasePipelineByOrgList403Error = {
    Forbidden: 'Forbidden'
};
const GetReleasePipelineByOrgList403StatusCode = {
    NUMBER_403: 403
};
const GetReleasePipelineByProjectList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetReleasePipelineByProjectList401StatusCode = {
    NUMBER_401: 401
};
const GetReleasePipelineByProjectList403Error = {
    Forbidden: 'Forbidden'
};
const GetReleasePipelineByProjectList403StatusCode = {
    NUMBER_403: 403
};
const GetReleasePipelineByApplicationList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetReleasePipelineByApplicationList401StatusCode = {
    NUMBER_401: 401
};
const GetReleasePipelineByApplicationList403Error = {
    Forbidden: 'Forbidden'
};
const GetReleasePipelineByApplicationList403StatusCode = {
    NUMBER_403: 403
};
const GetReleasePipelineTagList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetReleasePipelineTagList401StatusCode = {
    NUMBER_401: 401
};
const GetReleasePipelineTagList403Error = {
    Forbidden: 'Forbidden'
};
const GetReleasePipelineTagList403StatusCode = {
    NUMBER_403: 403
};
const GetReleasePipelineEnvironmentList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetReleasePipelineEnvironmentList401StatusCode = {
    NUMBER_401: 401
};
const GetReleasePipelineEnvironmentList403Error = {
    Forbidden: 'Forbidden'
};
const GetReleasePipelineEnvironmentList403StatusCode = {
    NUMBER_403: 403
};
const GetReleasePipelineTargetListType = {
    environment: 'environment',
    tag: 'tag'
};
const GetReleasePipelineTargetList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetReleasePipelineTargetList401StatusCode = {
    NUMBER_401: 401
};
const GetReleasePipelineTargetList403Error = {
    Forbidden: 'Forbidden'
};
const GetReleasePipelineTargetList403StatusCode = {
    NUMBER_403: 403
};
const GetReleasePipelineTargetAuthors401Error = {
    Unauthorized: 'Unauthorized'
};
const GetReleasePipelineTargetAuthors401StatusCode = {
    NUMBER_401: 401
};
const GetReleasePipelineTargetAuthors403Error = {
    Forbidden: 'Forbidden'
};
const GetReleasePipelineTargetAuthors403StatusCode = {
    NUMBER_403: 403
};
const CreateReleaseCandidate400Error = {
    Bad_Request: 'Bad Request'
};
const CreateReleaseCandidate400StatusCode = {
    NUMBER_400: 400
};
const CreateReleaseCandidate401Error = {
    Unauthorized: 'Unauthorized'
};
const CreateReleaseCandidate401StatusCode = {
    NUMBER_401: 401
};
const CreateReleaseCandidate403Error = {
    Forbidden: 'Forbidden'
};
const CreateReleaseCandidate403StatusCode = {
    NUMBER_403: 403
};
const CreateReleaseCandidate404Error = {
    Not_Found: 'Not Found'
};
const CreateReleaseCandidate404StatusCode = {
    NUMBER_404: 404
};
const PromoteReleaseCandidate400Error = {
    Bad_Request: 'Bad Request'
};
const PromoteReleaseCandidate400StatusCode = {
    NUMBER_400: 400
};
const PromoteReleaseCandidate401Error = {
    Unauthorized: 'Unauthorized'
};
const PromoteReleaseCandidate401StatusCode = {
    NUMBER_401: 401
};
const PromoteReleaseCandidate403Error = {
    Forbidden: 'Forbidden'
};
const PromoteReleaseCandidate403StatusCode = {
    NUMBER_403: 403
};
const PromoteReleaseCandidate404Error = {
    Not_Found: 'Not Found'
};
const PromoteReleaseCandidate404StatusCode = {
    NUMBER_404: 404
};
const DeployTagToEnvironment400Error = {
    Bad_Request: 'Bad Request'
};
const DeployTagToEnvironment400StatusCode = {
    NUMBER_400: 400
};
const DeployTagToEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const DeployTagToEnvironment401StatusCode = {
    NUMBER_401: 401
};
const DeployTagToEnvironment403Error = {
    Forbidden: 'Forbidden'
};
const DeployTagToEnvironment403StatusCode = {
    NUMBER_403: 403
};
const DeployTagToEnvironment404Error = {
    Not_Found: 'Not Found'
};
const DeployTagToEnvironment404StatusCode = {
    NUMBER_404: 404
};
const DeleteReleaseCandidate401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteReleaseCandidate401StatusCode = {
    NUMBER_401: 401
};
const DeleteReleaseCandidate403Error = {
    Forbidden: 'Forbidden'
};
const DeleteReleaseCandidate403StatusCode = {
    NUMBER_403: 403
};
const DeleteReleaseCandidate404Error = {
    Not_Found: 'Not Found'
};
const DeleteReleaseCandidate404StatusCode = {
    NUMBER_404: 404
};
const SetEnvironmentOrder400Error = {
    Bad_Request: 'Bad Request'
};
const SetEnvironmentOrder400StatusCode = {
    NUMBER_400: 400
};
const SetEnvironmentOrder401Error = {
    Unauthorized: 'Unauthorized'
};
const SetEnvironmentOrder401StatusCode = {
    NUMBER_401: 401
};
const SetEnvironmentOrder403Error = {
    Forbidden: 'Forbidden'
};
const SetEnvironmentOrder403StatusCode = {
    NUMBER_403: 403
};
const RollbackEnvironment400Error = {
    Bad_Request: 'Bad Request'
};
const RollbackEnvironment400StatusCode = {
    NUMBER_400: 400
};
const RollbackEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const RollbackEnvironment401StatusCode = {
    NUMBER_401: 401
};
const RollbackEnvironment403Error = {
    Forbidden: 'Forbidden'
};
const RollbackEnvironment403StatusCode = {
    NUMBER_403: 403
};
const RollbackEnvironment404Error = {
    Not_Found: 'Not Found'
};
const RollbackEnvironment404StatusCode = {
    NUMBER_404: 404
};
const GetTargetHistory401Error = {
    Unauthorized: 'Unauthorized'
};
const GetTargetHistory401StatusCode = {
    NUMBER_401: 401
};
const GetTargetHistory403Error = {
    Forbidden: 'Forbidden'
};
const GetTargetHistory403StatusCode = {
    NUMBER_403: 403
};
const GetTargetHistory404Error = {
    Not_Found: 'Not Found'
};
const GetTargetHistory404StatusCode = {
    NUMBER_404: 404
};
const GetEnvironmentDeploymentLog401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentDeploymentLog401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentDeploymentLog403Error = {
    Forbidden: 'Forbidden'
};
const GetEnvironmentDeploymentLog403StatusCode = {
    NUMBER_403: 403
};
const GetEnvironmentDeploymentLog404Error = {
    Not_Found: 'Not Found'
};
const GetEnvironmentDeploymentLog404StatusCode = {
    NUMBER_404: 404
};
const GetUniqueTeamName401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUniqueTeamName401StatusCode = {
    NUMBER_401: 401
};
const GetUniqueTeamName404Error = {
    Not_Found: 'Not Found'
};
const GetUniqueTeamName404StatusCode = {
    NUMBER_404: 404
};
const CreateTeam400Error = {
    Bad_Request: 'Bad Request'
};
const CreateTeam400StatusCode = {
    NUMBER_400: 400
};
const CreateTeam401Error = {
    Unauthorized: 'Unauthorized'
};
const CreateTeam401StatusCode = {
    NUMBER_401: 401
};
const CreateTeam403Error = {
    Forbidden: 'Forbidden'
};
const CreateTeam403StatusCode = {
    NUMBER_403: 403
};
const CreateTeam404Error = {
    Not_Found: 'Not Found'
};
const CreateTeam404StatusCode = {
    NUMBER_404: 404
};
const CreateTeam409Error = {
    Conflict: 'Conflict'
};
const CreateTeam409StatusCode = {
    NUMBER_409: 409
};
const GetTeamList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetTeamList401StatusCode = {
    NUMBER_401: 401
};
const GetTeamList403Error = {
    Forbidden: 'Forbidden'
};
const GetTeamList403StatusCode = {
    NUMBER_403: 403
};
const GetTeamList404Error = {
    Not_Found: 'Not Found'
};
const GetTeamList404StatusCode = {
    NUMBER_404: 404
};
const GetTeam401Error = {
    Unauthorized: 'Unauthorized'
};
const GetTeam401StatusCode = {
    NUMBER_401: 401
};
const GetTeam403Error = {
    Forbidden: 'Forbidden'
};
const GetTeam403StatusCode = {
    NUMBER_403: 403
};
const GetTeam404Error = {
    Not_Found: 'Not Found'
};
const GetTeam404StatusCode = {
    NUMBER_404: 404
};
const UpdateTeam400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateTeam400StatusCode = {
    NUMBER_400: 400
};
const UpdateTeam401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateTeam401StatusCode = {
    NUMBER_401: 401
};
const UpdateTeam403Error = {
    Forbidden: 'Forbidden'
};
const UpdateTeam403StatusCode = {
    NUMBER_403: 403
};
const UpdateTeam404Error = {
    Not_Found: 'Not Found'
};
const UpdateTeam404StatusCode = {
    NUMBER_404: 404
};
const UpdateTeam409Error = {
    Conflict: 'Conflict'
};
const UpdateTeam409StatusCode = {
    NUMBER_409: 409
};
const DeleteTeam401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteTeam401StatusCode = {
    NUMBER_401: 401
};
const DeleteTeam403Error = {
    Forbidden: 'Forbidden'
};
const DeleteTeam403StatusCode = {
    NUMBER_403: 403
};
const DeleteTeam404Error = {
    Not_Found: 'Not Found'
};
const DeleteTeam404StatusCode = {
    NUMBER_404: 404
};
const GetTeamMembers401Error = {
    Unauthorized: 'Unauthorized'
};
const GetTeamMembers401StatusCode = {
    NUMBER_401: 401
};
const GetTeamMembers403Error = {
    Forbidden: 'Forbidden'
};
const GetTeamMembers403StatusCode = {
    NUMBER_403: 403
};
const GetTeamMembers404Error = {
    Not_Found: 'Not Found'
};
const GetTeamMembers404StatusCode = {
    NUMBER_404: 404
};
const GetTeamByName401Error = {
    Unauthorized: 'Unauthorized'
};
const GetTeamByName401StatusCode = {
    NUMBER_401: 401
};
const GetTeamByName403Error = {
    Forbidden: 'Forbidden'
};
const GetTeamByName403StatusCode = {
    NUMBER_403: 403
};
const GetTeamByName404Error = {
    Not_Found: 'Not Found'
};
const GetTeamByName404StatusCode = {
    NUMBER_404: 404
};
const AddTeamMembers400Error = {
    Bad_Request: 'Bad Request'
};
const AddTeamMembers400StatusCode = {
    NUMBER_400: 400
};
const AddTeamMembers401Error = {
    Unauthorized: 'Unauthorized'
};
const AddTeamMembers401StatusCode = {
    NUMBER_401: 401
};
const AddTeamMembers403Error = {
    Forbidden: 'Forbidden'
};
const AddTeamMembers403StatusCode = {
    NUMBER_403: 403
};
const AddTeamMembers404Error = {
    Not_Found: 'Not Found'
};
const AddTeamMembers404StatusCode = {
    NUMBER_404: 404
};
const AddTeamMembers409Error = {
    Conflict: 'Conflict'
};
const AddTeamMembers409StatusCode = {
    NUMBER_409: 409
};
const UpdateTeamMemberRole400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateTeamMemberRole400StatusCode = {
    NUMBER_400: 400
};
const UpdateTeamMemberRole401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateTeamMemberRole401StatusCode = {
    NUMBER_401: 401
};
const UpdateTeamMemberRole403Error = {
    Forbidden: 'Forbidden'
};
const UpdateTeamMemberRole403StatusCode = {
    NUMBER_403: 403
};
const UpdateTeamMemberRole404Error = {
    Not_Found: 'Not Found'
};
const UpdateTeamMemberRole404StatusCode = {
    NUMBER_404: 404
};
const RemoveTeamMember401Error = {
    Unauthorized: 'Unauthorized'
};
const RemoveTeamMember401StatusCode = {
    NUMBER_401: 401
};
const RemoveTeamMember403Error = {
    Forbidden: 'Forbidden'
};
const RemoveTeamMember403StatusCode = {
    NUMBER_403: 403
};
const RemoveTeamMember404Error = {
    Not_Found: 'Not Found'
};
const RemoveTeamMember404StatusCode = {
    NUMBER_404: 404
};
const GetSubscription401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSubscription401StatusCode = {
    NUMBER_401: 401
};
const GetSubscription403Error = {
    Forbidden: 'Forbidden'
};
const GetSubscription403StatusCode = {
    NUMBER_403: 403
};
const GetSubscription404Error = {
    Not_Found: 'Not Found'
};
const GetSubscription404StatusCode = {
    NUMBER_404: 404
};
const ChangeSubscription400Error = {
    Bad_Request: 'Bad Request'
};
const ChangeSubscription400StatusCode = {
    NUMBER_400: 400
};
const ChangeSubscription404Error = {
    Not_Found: 'Not Found'
};
const ChangeSubscription404StatusCode = {
    NUMBER_404: 404
};
const CancelSubscriptionSchedule400Error = {
    Bad_Request: 'Bad Request'
};
const CancelSubscriptionSchedule400StatusCode = {
    NUMBER_400: 400
};
const CancelSubscriptionSchedule404Error = {
    Not_Found: 'Not Found'
};
const CancelSubscriptionSchedule404StatusCode = {
    NUMBER_404: 404
};
const AdvanceSubscriptionSchedule400Error = {
    Bad_Request: 'Bad Request'
};
const AdvanceSubscriptionSchedule400StatusCode = {
    NUMBER_400: 400
};
const ListQuotas404Error = {
    Not_Found: 'Not Found'
};
const ListQuotas404StatusCode = {
    NUMBER_404: 404
};
const UpdateRecurringQuota400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateRecurringQuota400StatusCode = {
    NUMBER_400: 400
};
const UpdateNonRecurringQuota400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateNonRecurringQuota400StatusCode = {
    NUMBER_400: 400
};
const ListCurrentUsage404Error = {
    Not_Found: 'Not Found'
};
const ListCurrentUsage404StatusCode = {
    NUMBER_404: 404
};
const ListCurrentMetricUsage404Error = {
    Not_Found: 'Not Found'
};
const ListCurrentMetricUsage404StatusCode = {
    NUMBER_404: 404
};
const GraphCurrentUsage404Error = {
    Not_Found: 'Not Found'
};
const GraphCurrentUsage404StatusCode = {
    NUMBER_404: 404
};
const ListChildOrganizations404Error = {
    Not_Found: 'Not Found'
};
const ListChildOrganizations404StatusCode = {
    NUMBER_404: 404
};
const InviteChildOrganization400Error = {
    Bad_Request: 'Bad Request'
};
const InviteChildOrganization400StatusCode = {
    NUMBER_400: 400
};
const CheckCanJoinAsChild400Error = {
    Bad_Request: 'Bad Request'
};
const CheckCanJoinAsChild400StatusCode = {
    NUMBER_400: 400
};
const DeleteInviteChildOrganization404Error = {
    Not_Found: 'Not Found'
};
const DeleteInviteChildOrganization404StatusCode = {
    NUMBER_404: 404
};
const GetInviteInformation404Error = {
    Not_Found: 'Not Found'
};
const GetInviteInformation404StatusCode = {
    NUMBER_404: 404
};
const RejectChildOrganizationInvite404Error = {
    Not_Found: 'Not Found'
};
const RejectChildOrganizationInvite404StatusCode = {
    NUMBER_404: 404
};
const AcceptChildOrganizationInvite404Error = {
    Not_Found: 'Not Found'
};
const AcceptChildOrganizationInvite404StatusCode = {
    NUMBER_404: 404
};
const ListInvoicesStatus = {
    draft: 'draft',
    open: 'open',
    paid: 'paid',
    uncollectible: 'uncollectible',
    void: 'void'
};
const ListInvoices404Error = {
    Not_Found: 'Not Found'
};
const ListInvoices404StatusCode = {
    NUMBER_404: 404
};
const GetUpcomingInvoice400Error = {
    Bad_Request: 'Bad Request'
};
const GetUpcomingInvoice400StatusCode = {
    NUMBER_400: 400
};
const GetUpcomingInvoice404Error = {
    Not_Found: 'Not Found'
};
const GetUpcomingInvoice404StatusCode = {
    NUMBER_404: 404
};
const ListPaymentMethods404Error = {
    Not_Found: 'Not Found'
};
const ListPaymentMethods404StatusCode = {
    NUMBER_404: 404
};
const AttachPaymentMethod400Error = {
    Bad_Request: 'Bad Request'
};
const AttachPaymentMethod400StatusCode = {
    NUMBER_400: 400
};
const DetachPaymentMethod400Error = {
    Bad_Request: 'Bad Request'
};
const DetachPaymentMethod400StatusCode = {
    NUMBER_400: 400
};
const SetDefaultPaymentMethod400Error = {
    Bad_Request: 'Bad Request'
};
const SetDefaultPaymentMethod400StatusCode = {
    NUMBER_400: 400
};
const GetDefaultPaymentMethod404Error = {
    Not_Found: 'Not Found'
};
const GetDefaultPaymentMethod404StatusCode = {
    NUMBER_404: 404
};
const GetStripeSubscriptionItems404Error = {
    Not_Found: 'Not Found'
};
const GetStripeSubscriptionItems404StatusCode = {
    NUMBER_404: 404
};
const RemoveCoupon404Error = {
    Not_Found: 'Not Found'
};
const RemoveCoupon404StatusCode = {
    NUMBER_404: 404
};
const GetSidePanelApplicationList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSidePanelApplicationList401StatusCode = {
    NUMBER_401: 401
};
const GetSidePanelApplicationEnvironmentList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSidePanelApplicationEnvironmentList401StatusCode = {
    NUMBER_401: 401
};
const GetSidePanelApplicationEnvironmentList404Error = {
    Not_Found: 'Not Found'
};
const GetSidePanelApplicationEnvironmentList404StatusCode = {
    NUMBER_404: 404
};
const GetSidePanelApplicationTagList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSidePanelApplicationTagList401StatusCode = {
    NUMBER_401: 401
};
const GetSidePanelApplicationTagList404Error = {
    Not_Found: 'Not Found'
};
const GetSidePanelApplicationTagList404StatusCode = {
    NUMBER_404: 404
};
const GetSidePanelApplicationVersionList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSidePanelApplicationVersionList401StatusCode = {
    NUMBER_401: 401
};
const GetSidePanelApplicationVersionList404Error = {
    Not_Found: 'Not Found'
};
const GetSidePanelApplicationVersionList404StatusCode = {
    NUMBER_404: 404
};
const GetSidePanelApplicationRemoteVersions400Error = {
    Bad_Request: 'Bad Request'
};
const GetSidePanelApplicationRemoteVersions400StatusCode = {
    NUMBER_400: 400
};
const GetSidePanelApplicationRemoteVersions401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSidePanelApplicationRemoteVersions401StatusCode = {
    NUMBER_401: 401
};
const DeploySidePanelVersion400Error = {
    Bad_Request: 'Bad Request'
};
const DeploySidePanelVersion400StatusCode = {
    NUMBER_400: 400
};
const DeploySidePanelVersion401Error = {
    Unauthorized: 'Unauthorized'
};
const DeploySidePanelVersion401StatusCode = {
    NUMBER_401: 401
};
const GetSidePanelDeployedVersionsList400Error = {
    Bad_Request: 'Bad Request'
};
const GetSidePanelDeployedVersionsList400StatusCode = {
    NUMBER_400: 400
};
const GetSidePanelDeployedVersionsList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSidePanelDeployedVersionsList401StatusCode = {
    NUMBER_401: 401
};
const GetSpApplicationList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSpApplicationList401StatusCode = {
    NUMBER_401: 401
};
const GetSpAppEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSpAppEnvironment401StatusCode = {
    NUMBER_401: 401
};
const GetSpAppEnvironment404Error = {
    Not_Found: 'Not Found'
};
const GetSpAppEnvironment404StatusCode = {
    NUMBER_404: 404
};
const GetSpAppTagList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSpAppTagList401StatusCode = {
    NUMBER_401: 401
};
const GetSpAppTagList404Error = {
    Not_Found: 'Not Found'
};
const GetSpAppTagList404StatusCode = {
    NUMBER_404: 404
};
const GetSpAppVersionList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSpAppVersionList401StatusCode = {
    NUMBER_401: 401
};
const GetSpAppVersionList404Error = {
    Not_Found: 'Not Found'
};
const GetSpAppVersionList404StatusCode = {
    NUMBER_404: 404
};
const GetSpAppVersion400Error = {
    Bad_Request: 'Bad Request'
};
const GetSpAppVersion400StatusCode = {
    NUMBER_400: 400
};
const GetSpAppVersion401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSpAppVersion401StatusCode = {
    NUMBER_401: 401
};
const PostSpVersionDeploy400Error = {
    Bad_Request: 'Bad Request'
};
const PostSpVersionDeploy400StatusCode = {
    NUMBER_400: 400
};
const PostSpVersionDeploy401Error = {
    Unauthorized: 'Unauthorized'
};
const PostSpVersionDeploy401StatusCode = {
    NUMBER_401: 401
};
const GetSpVersionDeployList400Error = {
    Bad_Request: 'Bad Request'
};
const GetSpVersionDeployList400StatusCode = {
    NUMBER_400: 400
};
const GetSpVersionDeployList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetSpVersionDeployList401StatusCode = {
    NUMBER_401: 401
};
const GetOrgNavigationItems401Error = {
    Unauthorized: 'Unauthorized'
};
const GetOrgNavigationItems401StatusCode = {
    NUMBER_401: 401
};
const GetProjNavigationItems401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjNavigationItems401StatusCode = {
    NUMBER_401: 401
};
const GetAppNavigationItems401Error = {
    Unauthorized: 'Unauthorized'
};
const GetAppNavigationItems401StatusCode = {
    NUMBER_401: 401
};
const PinNavigationItem400Error = {
    Bad_Request: 'Bad Request'
};
const PinNavigationItem400StatusCode = {
    NUMBER_400: 400
};
const PinNavigationItem401Error = {
    Unauthorized: 'Unauthorized'
};
const PinNavigationItem401StatusCode = {
    NUMBER_401: 401
};
const UnpinNavigationItem400Error = {
    Bad_Request: 'Bad Request'
};
const UnpinNavigationItem400StatusCode = {
    NUMBER_400: 400
};
const UnpinNavigationItem401Error = {
    Unauthorized: 'Unauthorized'
};
const UnpinNavigationItem401StatusCode = {
    NUMBER_401: 401
};
const GenerateUserAuthToken400Error = {
    Bad_Request: 'Bad Request'
};
const GenerateUserAuthToken400StatusCode = {
    NUMBER_400: 400
};
const GenerateUserAuthToken401Error = {
    Unauthorized: 'Unauthorized'
};
const GenerateUserAuthToken401StatusCode = {
    NUMBER_401: 401
};
const GenerateUserAuthToken409Error = {
    Conflict: 'Conflict'
};
const GenerateUserAuthToken409StatusCode = {
    NUMBER_409: 409
};
const ListUserAuthTokens401Error = {
    Unauthorized: 'Unauthorized'
};
const ListUserAuthTokens401StatusCode = {
    NUMBER_401: 401
};
const GetUserAuthToken401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserAuthToken401StatusCode = {
    NUMBER_401: 401
};
const GetUserAuthToken404Error = {
    Not_Found: 'Not Found'
};
const GetUserAuthToken404StatusCode = {
    NUMBER_404: 404
};
const EditUserAuthToken401Error = {
    Unauthorized: 'Unauthorized'
};
const EditUserAuthToken401StatusCode = {
    NUMBER_401: 401
};
const EditUserAuthToken404Error = {
    Not_Found: 'Not Found'
};
const EditUserAuthToken404StatusCode = {
    NUMBER_404: 404
};
const DeleteUserAuthToken401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteUserAuthToken401StatusCode = {
    NUMBER_401: 401
};
const DeleteUserAuthToken404Error = {
    Not_Found: 'Not Found'
};
const DeleteUserAuthToken404StatusCode = {
    NUMBER_404: 404
};
const UpdateUserAuthTokenName401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateUserAuthTokenName401StatusCode = {
    NUMBER_401: 401
};
const UpdateUserAuthTokenName404Error = {
    Not_Found: 'Not Found'
};
const UpdateUserAuthTokenName404StatusCode = {
    NUMBER_404: 404
};
const UpdateUserAuthTokenName409Error = {
    Conflict: 'Conflict'
};
const UpdateUserAuthTokenName409StatusCode = {
    NUMBER_409: 409
};
const IsUserAuthTokenNameUnique401Error = {
    Unauthorized: 'Unauthorized'
};
const IsUserAuthTokenNameUnique401StatusCode = {
    NUMBER_401: 401
};
const GetServerAuthTokenList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetServerAuthTokenList401StatusCode = {
    NUMBER_401: 401
};
const GetServerAuthTokenList403Error = {
    Forbidden: 'Forbidden'
};
const GetServerAuthTokenList403StatusCode = {
    NUMBER_403: 403
};
const CreateServerAuthToken400Error = {
    Bad_Request: 'Bad Request'
};
const CreateServerAuthToken400StatusCode = {
    NUMBER_400: 400
};
const CreateServerAuthToken401Error = {
    Unauthorized: 'Unauthorized'
};
const CreateServerAuthToken401StatusCode = {
    NUMBER_401: 401
};
const CreateServerAuthToken403Error = {
    Forbidden: 'Forbidden'
};
const CreateServerAuthToken403StatusCode = {
    NUMBER_403: 403
};
const CreateServerAuthToken409Error = {
    Conflict: 'Conflict'
};
const CreateServerAuthToken409StatusCode = {
    NUMBER_409: 409
};
const GetServerAuthToken401Error = {
    Unauthorized: 'Unauthorized'
};
const GetServerAuthToken401StatusCode = {
    NUMBER_401: 401
};
const GetServerAuthToken403Error = {
    Forbidden: 'Forbidden'
};
const GetServerAuthToken403StatusCode = {
    NUMBER_403: 403
};
const GetServerAuthToken404Error = {
    Not_Found: 'Not Found'
};
const GetServerAuthToken404StatusCode = {
    NUMBER_404: 404
};
const UpdateServerAuthToken401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateServerAuthToken401StatusCode = {
    NUMBER_401: 401
};
const UpdateServerAuthToken403Error = {
    Forbidden: 'Forbidden'
};
const UpdateServerAuthToken403StatusCode = {
    NUMBER_403: 403
};
const UpdateServerAuthToken404Error = {
    Not_Found: 'Not Found'
};
const UpdateServerAuthToken404StatusCode = {
    NUMBER_404: 404
};
const DeleteServerAuthToken401Error = {
    Unauthorized: 'Unauthorized'
};
const DeleteServerAuthToken401StatusCode = {
    NUMBER_401: 401
};
const DeleteServerAuthToken403Error = {
    Forbidden: 'Forbidden'
};
const DeleteServerAuthToken403StatusCode = {
    NUMBER_403: 403
};
const DeleteServerAuthToken404Error = {
    Not_Found: 'Not Found'
};
const DeleteServerAuthToken404StatusCode = {
    NUMBER_404: 404
};
const IsServerAuthTokenNameUnique401Error = {
    Unauthorized: 'Unauthorized'
};
const IsServerAuthTokenNameUnique401StatusCode = {
    NUMBER_401: 401
};
const IsServerAuthTokenNameUnique403Error = {
    Forbidden: 'Forbidden'
};
const IsServerAuthTokenNameUnique403StatusCode = {
    NUMBER_403: 403
};
const Create400Error = {
    Bad_Request: 'Bad Request'
};
const Create400StatusCode = {
    NUMBER_400: 400
};
const Create401Error = {
    Unauthorized: 'Unauthorized'
};
const Create401StatusCode = {
    NUMBER_401: 401
};
const Create403Error = {
    Forbidden: 'Forbidden'
};
const Create403StatusCode = {
    NUMBER_403: 403
};
const Create404Error = {
    Not_Found: 'Not Found'
};
const Create404StatusCode = {
    NUMBER_404: 404
};
const GetList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetList401StatusCode = {
    NUMBER_401: 401
};
const GetList403Error = {
    Forbidden: 'Forbidden'
};
const GetList403StatusCode = {
    NUMBER_403: 403
};
const GetList404Error = {
    Not_Found: 'Not Found'
};
const GetList404StatusCode = {
    NUMBER_404: 404
};
const GetEnabledList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnabledList401StatusCode = {
    NUMBER_401: 401
};
const GetEnabledList404Error = {
    Not_Found: 'Not Found'
};
const GetEnabledList404StatusCode = {
    NUMBER_404: 404
};
const GetDeploymentIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const GetDeploymentIntegration401StatusCode = {
    NUMBER_401: 401
};
const GetDeploymentIntegration404Error = {
    Not_Found: 'Not Found'
};
const GetDeploymentIntegration404StatusCode = {
    NUMBER_404: 404
};
const UpdateOrganizationDeploymentIntegration400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateOrganizationDeploymentIntegration400StatusCode = {
    NUMBER_400: 400
};
const UpdateOrganizationDeploymentIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateOrganizationDeploymentIntegration401StatusCode = {
    NUMBER_401: 401
};
const UpdateOrganizationDeploymentIntegration403Error = {
    Forbidden: 'Forbidden'
};
const UpdateOrganizationDeploymentIntegration403StatusCode = {
    NUMBER_403: 403
};
const UpdateOrganizationDeploymentIntegration404Error = {
    Not_Found: 'Not Found'
};
const UpdateOrganizationDeploymentIntegration404StatusCode = {
    NUMBER_404: 404
};
const _Delete401Error = {
    Unauthorized: 'Unauthorized'
};
const _Delete401StatusCode = {
    NUMBER_401: 401
};
const _Delete403Error = {
    Forbidden: 'Forbidden'
};
const _Delete403StatusCode = {
    NUMBER_403: 403
};
const _Delete404Error = {
    Not_Found: 'Not Found'
};
const _Delete404StatusCode = {
    NUMBER_404: 404
};
const UpdateWorker400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateWorker400StatusCode = {
    NUMBER_400: 400
};
const UpdateWorker401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateWorker401StatusCode = {
    NUMBER_401: 401
};
const UpdateWorker403Error = {
    Forbidden: 'Forbidden'
};
const UpdateWorker403StatusCode = {
    NUMBER_403: 403
};
const UpdateWorker404Error = {
    Not_Found: 'Not Found'
};
const UpdateWorker404StatusCode = {
    NUMBER_404: 404
};
const CreateMultiCdn400Error = {
    Bad_Request: 'Bad Request'
};
const CreateMultiCdn400StatusCode = {
    NUMBER_400: 400
};
const CreateMultiCdn401Error = {
    Unauthorized: 'Unauthorized'
};
const CreateMultiCdn401StatusCode = {
    NUMBER_401: 401
};
const CreateMultiCdn403Error = {
    Forbidden: 'Forbidden'
};
const CreateMultiCdn403StatusCode = {
    NUMBER_403: 403
};
const CreateMultiCdn404Error = {
    Not_Found: 'Not Found'
};
const CreateMultiCdn404StatusCode = {
    NUMBER_404: 404
};
const GetMultiCdnList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetMultiCdnList401StatusCode = {
    NUMBER_401: 401
};
const GetMultiCdnList404Error = {
    Not_Found: 'Not Found'
};
const GetMultiCdnList404StatusCode = {
    NUMBER_404: 404
};
const SetDefault401Error = {
    Unauthorized: 'Unauthorized'
};
const SetDefault401StatusCode = {
    NUMBER_401: 401
};
const SetDefault403Error = {
    Forbidden: 'Forbidden'
};
const SetDefault403StatusCode = {
    NUMBER_403: 403
};
const SetDefault404Error = {
    Not_Found: 'Not Found'
};
const SetDefault404StatusCode = {
    NUMBER_404: 404
};
const UnsetDefault401Error = {
    Unauthorized: 'Unauthorized'
};
const UnsetDefault401StatusCode = {
    NUMBER_401: 401
};
const UnsetDefault403Error = {
    Forbidden: 'Forbidden'
};
const UnsetDefault403StatusCode = {
    NUMBER_403: 403
};
const UnsetDefault404Error = {
    Not_Found: 'Not Found'
};
const UnsetDefault404StatusCode = {
    NUMBER_404: 404
};
const ToggleEnabled401Error = {
    Unauthorized: 'Unauthorized'
};
const ToggleEnabled401StatusCode = {
    NUMBER_401: 401
};
const ToggleEnabled403Error = {
    Forbidden: 'Forbidden'
};
const ToggleEnabled403StatusCode = {
    NUMBER_403: 403
};
const ToggleEnabled404Error = {
    Not_Found: 'Not Found'
};
const ToggleEnabled404StatusCode = {
    NUMBER_404: 404
};
const SetZephyrAsDefault401Error = {
    Unauthorized: 'Unauthorized'
};
const SetZephyrAsDefault401StatusCode = {
    NUMBER_401: 401
};
const SetZephyrAsDefault403Error = {
    Forbidden: 'Forbidden'
};
const SetZephyrAsDefault403StatusCode = {
    NUMBER_403: 403
};
const SetZephyrAsDefault404Error = {
    Not_Found: 'Not Found'
};
const SetZephyrAsDefault404StatusCode = {
    NUMBER_404: 404
};
const IsUserZephyrTeam401Error = {
    Unauthorized: 'Unauthorized'
};
const IsUserZephyrTeam401StatusCode = {
    NUMBER_401: 401
};
const Retry401Error = {
    Unauthorized: 'Unauthorized'
};
const Retry401StatusCode = {
    NUMBER_401: 401
};
const Retry403Error = {
    Forbidden: 'Forbidden'
};
const Retry403StatusCode = {
    NUMBER_403: 403
};
const Retry404Error = {
    Not_Found: 'Not Found'
};
const Retry404StatusCode = {
    NUMBER_404: 404
};
const ChangeOrganizationDeploymentIntegrationName400Error = {
    Bad_Request: 'Bad Request'
};
const ChangeOrganizationDeploymentIntegrationName400StatusCode = {
    NUMBER_400: 400
};
const ChangeOrganizationDeploymentIntegrationName401Error = {
    Unauthorized: 'Unauthorized'
};
const ChangeOrganizationDeploymentIntegrationName401StatusCode = {
    NUMBER_401: 401
};
const ChangeOrganizationDeploymentIntegrationName403Error = {
    Forbidden: 'Forbidden'
};
const ChangeOrganizationDeploymentIntegrationName403StatusCode = {
    NUMBER_403: 403
};
const ChangeOrganizationDeploymentIntegrationName404Error = {
    Not_Found: 'Not Found'
};
const ChangeOrganizationDeploymentIntegrationName404StatusCode = {
    NUMBER_404: 404
};
const ChangeOrganizationDeploymentIntegrationName409Error = {
    Bad_Request: 'Bad Request'
};
const ChangeOrganizationDeploymentIntegrationName409StatusCode = {
    NUMBER_400: 400
};
const SetDefaultProjectIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const SetDefaultProjectIntegration401StatusCode = {
    NUMBER_401: 401
};
const SetDefaultProjectIntegration403Error = {
    Forbidden: 'Forbidden'
};
const SetDefaultProjectIntegration403StatusCode = {
    NUMBER_403: 403
};
const SetDefaultProjectIntegration404Error = {
    Not_Found: 'Not Found'
};
const SetDefaultProjectIntegration404StatusCode = {
    NUMBER_404: 404
};
const UnsetDefaultProjectIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const UnsetDefaultProjectIntegration401StatusCode = {
    NUMBER_401: 401
};
const UnsetDefaultProjectIntegration403Error = {
    Forbidden: 'Forbidden'
};
const UnsetDefaultProjectIntegration403StatusCode = {
    NUMBER_403: 403
};
const UnsetDefaultProjectIntegration404Error = {
    Not_Found: 'Not Found'
};
const UnsetDefaultProjectIntegration404StatusCode = {
    NUMBER_404: 404
};
const GetProjectIntegrationList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectIntegrationList401StatusCode = {
    NUMBER_401: 401
};
const GetProjectIntegrationList404Error = {
    Not_Found: 'Not Found'
};
const GetProjectIntegrationList404StatusCode = {
    NUMBER_404: 404
};
const GetProjectDeploymentIntegrationApps401Error = {
    Unauthorized: 'Unauthorized'
};
const GetProjectDeploymentIntegrationApps401StatusCode = {
    NUMBER_401: 401
};
const GetProjectDeploymentIntegrationApps404Error = {
    Not_Found: 'Not Found'
};
const GetProjectDeploymentIntegrationApps404StatusCode = {
    NUMBER_404: 404
};
const SetDeploymentIntegrationAllAppsToProjectDefault401Error = {
    Unauthorized: 'Unauthorized'
};
const SetDeploymentIntegrationAllAppsToProjectDefault401StatusCode = {
    NUMBER_401: 401
};
const SetDeploymentIntegrationAllAppsToProjectDefault403Error = {
    Forbidden: 'Forbidden'
};
const SetDeploymentIntegrationAllAppsToProjectDefault403StatusCode = {
    NUMBER_403: 403
};
const SetDeploymentIntegrationAllAppsToProjectDefault404Error = {
    Not_Found: 'Not Found'
};
const SetDeploymentIntegrationAllAppsToProjectDefault404StatusCode = {
    NUMBER_404: 404
};
const SetZephyrAsDefaultProjectIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const SetZephyrAsDefaultProjectIntegration401StatusCode = {
    NUMBER_401: 401
};
const SetZephyrAsDefaultProjectIntegration403Error = {
    Forbidden: 'Forbidden'
};
const SetZephyrAsDefaultProjectIntegration403StatusCode = {
    NUMBER_403: 403
};
const SetZephyrAsDefaultProjectIntegration404Error = {
    Not_Found: 'Not Found'
};
const SetZephyrAsDefaultProjectIntegration404StatusCode = {
    NUMBER_404: 404
};
const SetDefaultApplicationIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const SetDefaultApplicationIntegration401StatusCode = {
    NUMBER_401: 401
};
const SetDefaultApplicationIntegration403Error = {
    Forbidden: 'Forbidden'
};
const SetDefaultApplicationIntegration403StatusCode = {
    NUMBER_403: 403
};
const SetDefaultApplicationIntegration404Error = {
    Not_Found: 'Not Found'
};
const SetDefaultApplicationIntegration404StatusCode = {
    NUMBER_404: 404
};
const UnsetDefaultApplicationIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const UnsetDefaultApplicationIntegration401StatusCode = {
    NUMBER_401: 401
};
const UnsetDefaultApplicationIntegration403Error = {
    Forbidden: 'Forbidden'
};
const UnsetDefaultApplicationIntegration403StatusCode = {
    NUMBER_403: 403
};
const UnsetDefaultApplicationIntegration404Error = {
    Not_Found: 'Not Found'
};
const UnsetDefaultApplicationIntegration404StatusCode = {
    NUMBER_404: 404
};
const GetApplicationIntegrationList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetApplicationIntegrationList401StatusCode = {
    NUMBER_401: 401
};
const GetApplicationIntegrationList404Error = {
    Not_Found: 'Not Found'
};
const GetApplicationIntegrationList404StatusCode = {
    NUMBER_404: 404
};
const SetZephyrAsDefaultApplicationIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const SetZephyrAsDefaultApplicationIntegration401StatusCode = {
    NUMBER_401: 401
};
const SetZephyrAsDefaultApplicationIntegration403Error = {
    Forbidden: 'Forbidden'
};
const SetZephyrAsDefaultApplicationIntegration403StatusCode = {
    NUMBER_403: 403
};
const SetZephyrAsDefaultApplicationIntegration404Error = {
    Not_Found: 'Not Found'
};
const SetZephyrAsDefaultApplicationIntegration404StatusCode = {
    NUMBER_404: 404
};
const GetEnvironmentDeploymentIntegrationList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentDeploymentIntegrationList401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentDeploymentIntegrationList404Error = {
    Not_Found: 'Not Found'
};
const GetEnvironmentDeploymentIntegrationList404StatusCode = {
    NUMBER_404: 404
};
const SetEnvironmentDeploymentIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const SetEnvironmentDeploymentIntegration401StatusCode = {
    NUMBER_401: 401
};
const SetEnvironmentDeploymentIntegration403Error = {
    Forbidden: 'Forbidden'
};
const SetEnvironmentDeploymentIntegration403StatusCode = {
    NUMBER_403: 403
};
const SetEnvironmentDeploymentIntegration404Error = {
    Not_Found: 'Not Found'
};
const SetEnvironmentDeploymentIntegration404StatusCode = {
    NUMBER_404: 404
};
const UnsetEnvironmentDeploymentIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const UnsetEnvironmentDeploymentIntegration401StatusCode = {
    NUMBER_401: 401
};
const UnsetEnvironmentDeploymentIntegration403Error = {
    Forbidden: 'Forbidden'
};
const UnsetEnvironmentDeploymentIntegration403StatusCode = {
    NUMBER_403: 403
};
const UnsetEnvironmentDeploymentIntegration404Error = {
    Not_Found: 'Not Found'
};
const UnsetEnvironmentDeploymentIntegration404StatusCode = {
    NUMBER_404: 404
};
const SetZephyrAsDefaultEnvironmentIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const SetZephyrAsDefaultEnvironmentIntegration401StatusCode = {
    NUMBER_401: 401
};
const SetZephyrAsDefaultEnvironmentIntegration403Error = {
    Forbidden: 'Forbidden'
};
const SetZephyrAsDefaultEnvironmentIntegration403StatusCode = {
    NUMBER_403: 403
};
const SetZephyrAsDefaultEnvironmentIntegration404Error = {
    Not_Found: 'Not Found'
};
const SetZephyrAsDefaultEnvironmentIntegration404StatusCode = {
    NUMBER_404: 404
};
const GetEnvironmentIntegrations401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentIntegrations401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentIntegrations404Error = {
    Not_Found: 'Not Found'
};
const GetEnvironmentIntegrations404StatusCode = {
    NUMBER_404: 404
};
const AddIntegrationToEnvironment400Error = {
    Bad_Request: 'Bad Request'
};
const AddIntegrationToEnvironment400StatusCode = {
    NUMBER_400: 400
};
const AddIntegrationToEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const AddIntegrationToEnvironment401StatusCode = {
    NUMBER_401: 401
};
const AddIntegrationToEnvironment403Error = {
    Forbidden: 'Forbidden'
};
const AddIntegrationToEnvironment403StatusCode = {
    NUMBER_403: 403
};
const AddIntegrationToEnvironment404Error = {
    Not_Found: 'Not Found'
};
const AddIntegrationToEnvironment404StatusCode = {
    NUMBER_404: 404
};
const SetPrimaryIntegration401Error = {
    Unauthorized: 'Unauthorized'
};
const SetPrimaryIntegration401StatusCode = {
    NUMBER_401: 401
};
const SetPrimaryIntegration403Error = {
    Forbidden: 'Forbidden'
};
const SetPrimaryIntegration403StatusCode = {
    NUMBER_403: 403
};
const SetPrimaryIntegration404Error = {
    Not_Found: 'Not Found'
};
const SetPrimaryIntegration404StatusCode = {
    NUMBER_404: 404
};
const RemoveIntegrationFromEnvironment401Error = {
    Unauthorized: 'Unauthorized'
};
const RemoveIntegrationFromEnvironment401StatusCode = {
    NUMBER_401: 401
};
const RemoveIntegrationFromEnvironment403Error = {
    Forbidden: 'Forbidden'
};
const RemoveIntegrationFromEnvironment403StatusCode = {
    NUMBER_403: 403
};
const RemoveIntegrationFromEnvironment404Error = {
    Not_Found: 'Not Found'
};
const RemoveIntegrationFromEnvironment404StatusCode = {
    NUMBER_404: 404
};
const GetDeploymentStatus401Error = {
    Unauthorized: 'Unauthorized'
};
const GetDeploymentStatus401StatusCode = {
    NUMBER_401: 401
};
const GetDeploymentStatus404Error = {
    Not_Found: 'Not Found'
};
const GetDeploymentStatus404StatusCode = {
    NUMBER_404: 404
};
const GetUserProfileSettings401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserProfileSettings401StatusCode = {
    NUMBER_401: 401
};
const GetUserProfileSettings404Error = {
    Not_Found: 'Not Found'
};
const GetUserProfileSettings404StatusCode = {
    NUMBER_404: 404
};
const UpdateUserProfileSettings400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateUserProfileSettings400StatusCode = {
    NUMBER_400: 400
};
const UpdateUserProfileSettings401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateUserProfileSettings401StatusCode = {
    NUMBER_401: 401
};
const UpdateUserProfileSettings404Error = {
    Not_Found: 'Not Found'
};
const UpdateUserProfileSettings404StatusCode = {
    NUMBER_404: 404
};
const GetUserEmailOptions401Error = {
    Unauthorized: 'Unauthorized'
};
const GetUserEmailOptions401StatusCode = {
    NUMBER_401: 401
};
const GetUserEmailOptions404Error = {
    Not_Found: 'Not Found'
};
const GetUserEmailOptions404StatusCode = {
    NUMBER_404: 404
};
const UpdateUserEmailOptions400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateUserEmailOptions400StatusCode = {
    NUMBER_400: 400
};
const UpdateUserEmailOptions401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateUserEmailOptions401StatusCode = {
    NUMBER_401: 401
};
const UpdateUserEmailOptions404Error = {
    Not_Found: 'Not Found'
};
const UpdateUserEmailOptions404StatusCode = {
    NUMBER_404: 404
};
const ChangePassword400Error = {
    Bad_Request: 'Bad Request'
};
const ChangePassword400StatusCode = {
    NUMBER_400: 400
};
const ChangePassword401Error = {
    Unauthorized: 'Unauthorized'
};
const ChangePassword401StatusCode = {
    NUMBER_401: 401
};
const ResendVerificationEmail400Error = {
    Bad_Request: 'Bad Request'
};
const ResendVerificationEmail400StatusCode = {
    NUMBER_400: 400
};
const ResendVerificationEmail401Error = {
    Unauthorized: 'Unauthorized'
};
const ResendVerificationEmail401StatusCode = {
    NUMBER_401: 401
};
const DeactivateUserAccount401Error = {
    Unauthorized: 'Unauthorized'
};
const DeactivateUserAccount401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentAuditLog401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentAuditLog401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentAuditLog403Error = {
    Forbidden: 'Forbidden'
};
const GetEnvironmentAuditLog403StatusCode = {
    NUMBER_403: 403
};
const GetEnvironmentAuditLog404Error = {
    Not_Found: 'Not Found'
};
const GetEnvironmentAuditLog404StatusCode = {
    NUMBER_404: 404
};
const GetEnvironmentAuthors401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEnvironmentAuthors401StatusCode = {
    NUMBER_401: 401
};
const GetEnvironmentAuthors403Error = {
    Forbidden: 'Forbidden'
};
const GetEnvironmentAuthors403StatusCode = {
    NUMBER_403: 403
};
const GetEnvironmentAuthors404Error = {
    Not_Found: 'Not Found'
};
const GetEnvironmentAuthors404StatusCode = {
    NUMBER_404: 404
};
const UpdatePeople400Error = {
    Bad_Request: 'Bad Request'
};
const UpdatePeople400StatusCode = {
    NUMBER_400: 400
};
const UpdatePeople401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdatePeople401StatusCode = {
    NUMBER_401: 401
};
const UpdatePeople403Error = {
    Forbidden: 'Forbidden'
};
const UpdatePeople403StatusCode = {
    NUMBER_403: 403
};
const UpdatePeople404Error = {
    Not_Found: 'Not Found'
};
const UpdatePeople404StatusCode = {
    NUMBER_404: 404
};
const DeletePeople401Error = {
    Unauthorized: 'Unauthorized'
};
const DeletePeople401StatusCode = {
    NUMBER_401: 401
};
const DeletePeople403Error = {
    Forbidden: 'Forbidden'
};
const DeletePeople403StatusCode = {
    NUMBER_403: 403
};
const DeletePeople404Error = {
    Not_Found: 'Not Found'
};
const DeletePeople404StatusCode = {
    NUMBER_404: 404
};
const InvitePeople400Error = {
    Bad_Request: 'Bad Request'
};
const InvitePeople400StatusCode = {
    NUMBER_400: 400
};
const InvitePeople401Error = {
    Unauthorized: 'Unauthorized'
};
const InvitePeople401StatusCode = {
    NUMBER_401: 401
};
const InvitePeople403Error = {
    Forbidden: 'Forbidden'
};
const InvitePeople403StatusCode = {
    NUMBER_403: 403
};
const InvitePeople404Error = {
    Not_Found: 'Not Found'
};
const InvitePeople404StatusCode = {
    NUMBER_404: 404
};
const InvitePeople409Error = {
    Conflict: 'Conflict'
};
const InvitePeople409StatusCode = {
    NUMBER_409: 409
};
const GetPeopleList401Error = {
    Unauthorized: 'Unauthorized'
};
const GetPeopleList401StatusCode = {
    NUMBER_401: 401
};
const GetPeopleList403Error = {
    Forbidden: 'Forbidden'
};
const GetPeopleList403StatusCode = {
    NUMBER_403: 403
};
const GetPeopleList404Error = {
    Not_Found: 'Not Found'
};
const GetPeopleList404StatusCode = {
    NUMBER_404: 404
};
const ValidateAuthToken401Error = {
    Unauthorized: 'Unauthorized'
};
const ValidateAuthToken401StatusCode = {
    NUMBER_401: 401
};
const AuthLoginOrigin = {
    cli: 'cli',
    sidepanel: 'sidepanel',
    web: 'web'
};
const AuthLogin400Error = {
    Bad_Request: 'Bad Request'
};
const AuthLogin400StatusCode = {
    NUMBER_400: 400
};
const GetAuthorizeLinkOrigin = {
    cli: 'cli',
    sidepanel: 'sidepanel',
    web: 'web'
};
const GetAuthorizeLink400Error = {
    Bad_Request: 'Bad Request'
};
const GetAuthorizeLink400StatusCode = {
    NUMBER_400: 400
};
const GetAuthorizeWithUserInfoOrigin = {
    cli: 'cli',
    sidepanel: 'sidepanel',
    web: 'web'
};
const GetAuthorizeWithUserInfo400Error = {
    Bad_Request: 'Bad Request'
};
const GetAuthorizeWithUserInfo400StatusCode = {
    NUMBER_400: 400
};
const AuthorizeCallbackOrigin = {
    cli: 'cli',
    sidepanel: 'sidepanel',
    web: 'web'
};
const AuthorizeCallback400Error = {
    Bad_Request: 'Bad Request'
};
const AuthorizeCallback400StatusCode = {
    NUMBER_400: 400
};
const GetEmailPreferences401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEmailPreferences401StatusCode = {
    NUMBER_401: 401
};
const UpdateEmailPreferences400Error = {
    Bad_Request: 'Bad Request'
};
const UpdateEmailPreferences400StatusCode = {
    NUMBER_400: 400
};
const UpdateEmailPreferences401Error = {
    Unauthorized: 'Unauthorized'
};
const UpdateEmailPreferences401StatusCode = {
    NUMBER_401: 401
};
const CheckDomain400Error = {
    Bad_Request: 'Bad Request'
};
const CheckDomain400StatusCode = {
    NUMBER_400: 400
};
const CheckDomain401Error = {
    Unauthorized: 'Unauthorized'
};
const CheckDomain401StatusCode = {
    NUMBER_401: 401
};
const GetEntriConfig401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEntriConfig401StatusCode = {
    NUMBER_401: 401
};
const GetEntriConfig403Error = {
    Forbidden: 'Forbidden'
};
const GetEntriConfig403StatusCode = {
    NUMBER_403: 403
};
const GetEntriConfig404Error = {
    Not_Found: 'Not Found'
};
const GetEntriConfig404StatusCode = {
    NUMBER_404: 404
};
const GetEntriConnectUrl400Error = {
    Bad_Request: 'Bad Request'
};
const GetEntriConnectUrl400StatusCode = {
    NUMBER_400: 400
};
const GetEntriConnectUrl401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEntriConnectUrl401StatusCode = {
    NUMBER_401: 401
};
const GetEntriConnectUrl403Error = {
    Forbidden: 'Forbidden'
};
const GetEntriConnectUrl403StatusCode = {
    NUMBER_403: 403
};
const GetEntriDomainEligibility400Error = {
    Bad_Request: 'Bad Request'
};
const GetEntriDomainEligibility400StatusCode = {
    NUMBER_400: 400
};
const GetEntriDomainEligibility401Error = {
    Unauthorized: 'Unauthorized'
};
const GetEntriDomainEligibility401StatusCode = {
    NUMBER_401: 401
};
const GetEntriDomainEligibility403Error = {
    Forbidden: 'Forbidden'
};
const GetEntriDomainEligibility403StatusCode = {
    NUMBER_403: 403
};
const EntriPowerDomain400Error = {
    Bad_Request: 'Bad Request'
};
const EntriPowerDomain400StatusCode = {
    NUMBER_400: 400
};
const EntriPowerDomain401Error = {
    Unauthorized: 'Unauthorized'
};
const EntriPowerDomain401StatusCode = {
    NUMBER_401: 401
};
const EntriPowerDomain403Error = {
    Forbidden: 'Forbidden'
};
const EntriPowerDomain403StatusCode = {
    NUMBER_403: 403
};
const EntriUpdatePoweredDomain400Error = {
    Bad_Request: 'Bad Request'
};
const EntriUpdatePoweredDomain400StatusCode = {
    NUMBER_400: 400
};
const EntriUpdatePoweredDomain401Error = {
    Unauthorized: 'Unauthorized'
};
const EntriUpdatePoweredDomain401StatusCode = {
    NUMBER_401: 401
};
const EntriUpdatePoweredDomain403Error = {
    Forbidden: 'Forbidden'
};
const EntriUpdatePoweredDomain403StatusCode = {
    NUMBER_403: 403
};
const EntriRemovePoweredDomain401Error = {
    Unauthorized: 'Unauthorized'
};
const EntriRemovePoweredDomain401StatusCode = {
    NUMBER_401: 401
};
const EntriRemovePoweredDomain403Error = {
    Forbidden: 'Forbidden'
};
const EntriRemovePoweredDomain403StatusCode = {
    NUMBER_403: 403
};
const EntriRemovePoweredDomain404Error = {
    Not_Found: 'Not Found'
};
const EntriRemovePoweredDomain404StatusCode = {
    NUMBER_404: 404
};
export { AcceptChildOrganizationInvite404Error, AcceptChildOrganizationInvite404StatusCode, AddEnvironmentCustomDomain401Error, AddEnvironmentCustomDomain401StatusCode, AddEnvironmentCustomDomain403Error, AddEnvironmentCustomDomain403StatusCode, AddEnvironmentCustomDomain404Error, AddEnvironmentCustomDomain404StatusCode, AddEnvironmentMembers401Error, AddEnvironmentMembers401StatusCode, AddEnvironmentMembers403Error, AddEnvironmentMembers403StatusCode, AddEnvironmentMembers404Error, AddEnvironmentMembers404StatusCode, AddIntegrationToEnvironment400Error, AddIntegrationToEnvironment400StatusCode, AddIntegrationToEnvironment401Error, AddIntegrationToEnvironment401StatusCode, AddIntegrationToEnvironment403Error, AddIntegrationToEnvironment403StatusCode, AddIntegrationToEnvironment404Error, AddIntegrationToEnvironment404StatusCode, AddProjectContributors401Error, AddProjectContributors401StatusCode, AddProjectContributors403Error, AddProjectContributors403StatusCode, AddProjectContributors409Error, AddProjectContributors409StatusCode, AddTeamMembers400Error, AddTeamMembers400StatusCode, AddTeamMembers401Error, AddTeamMembers401StatusCode, AddTeamMembers403Error, AddTeamMembers403StatusCode, AddTeamMembers404Error, AddTeamMembers404StatusCode, AddTeamMembers409Error, AddTeamMembers409StatusCode, AdvanceSubscriptionSchedule400Error, AdvanceSubscriptionSchedule400StatusCode, AkamaiDeploymentConfigPlatform, AkamaiIntegrationPlatform, ApplicationAuditLogAction, ApplicationAuditLogResult, ApplicationAuditLogType, ApplicationProjectRefVisibility, ApplicationVersionDependenciesItemType, ApplicationVersionStatus, AttachPaymentMethod400Error, AttachPaymentMethod400StatusCode, AuditLogAction, AuditLogResult, AuditLogType, AuthLogin400Error, AuthLogin400StatusCode, AuthLoginOrigin, AuthorizeCallback400Error, AuthorizeCallback400StatusCode, AuthorizeCallbackOrigin, AwsDeploymentConfigPlatform, AwsIntegrationPlatform, CancelSubscriptionSchedule400Error, CancelSubscriptionSchedule400StatusCode, CancelSubscriptionSchedule404Error, CancelSubscriptionSchedule404StatusCode, ChangeOrganizationDeploymentIntegrationName400Error, ChangeOrganizationDeploymentIntegrationName400StatusCode, ChangeOrganizationDeploymentIntegrationName401Error, ChangeOrganizationDeploymentIntegrationName401StatusCode, ChangeOrganizationDeploymentIntegrationName403Error, ChangeOrganizationDeploymentIntegrationName403StatusCode, ChangeOrganizationDeploymentIntegrationName404Error, ChangeOrganizationDeploymentIntegrationName404StatusCode, ChangeOrganizationDeploymentIntegrationName409Error, ChangeOrganizationDeploymentIntegrationName409StatusCode, ChangePassword400Error, ChangePassword400StatusCode, ChangePassword401Error, ChangePassword401StatusCode, ChangeSubscription400Error, ChangeSubscription400StatusCode, ChangeSubscription404Error, ChangeSubscription404StatusCode, ChangeSubscriptionRequestNewBillingCycle, ChangeSubscriptionRequestNewTier, CheckCanJoinAsChild400Error, CheckCanJoinAsChild400StatusCode, CheckDevopsFeature401Error, CheckDevopsFeature401StatusCode, CheckDomain400Error, CheckDomain400StatusCode, CheckDomain401Error, CheckDomain401StatusCode, CloudflareDeploymentConfigPlatform, CloudflareIntegrationPlatform, ComparisonOperator, ContributorWithTypeType, CouponDtoForcedCycle, CouponDtoForcedTier, Create400Error, Create400StatusCode, Create401Error, Create401StatusCode, Create403Error, Create403StatusCode, Create404Error, Create404StatusCode, CreateApplication400Error, CreateApplication400StatusCode, CreateApplication401Error, CreateApplication401StatusCode, CreateApplication403Error, CreateApplication403StatusCode, CreateApplication404Error, CreateApplication404StatusCode, CreateApplication409Error, CreateApplication409StatusCode, CreateApplicationEnvironment401Error, CreateApplicationEnvironment401StatusCode, CreateApplicationEnvironment403Error, CreateApplicationEnvironment403StatusCode, CreateApplicationEnvironment404Error, CreateApplicationEnvironment404StatusCode, CreateApplicationEnvironmentBodyConditionChannel, CreateApplicationTag401Error, CreateApplicationTag401StatusCode, CreateApplicationTag403Error, CreateApplicationTag403StatusCode, CreateApplicationTag404Error, CreateApplicationTag404StatusCode, CreateMultiCdn400Error, CreateMultiCdn400StatusCode, CreateMultiCdn401Error, CreateMultiCdn401StatusCode, CreateMultiCdn403Error, CreateMultiCdn403StatusCode, CreateMultiCdn404Error, CreateMultiCdn404StatusCode, CreateOrganization400Error, CreateOrganization400StatusCode, CreateOrganization401Error, CreateOrganization401StatusCode, CreateOrganization409Error, CreateOrganization409StatusCode, CreateProject201ValueRole, CreateProject201ValueVisibility, CreateProject401Error, CreateProject401StatusCode, CreateProject403Error, CreateProject403StatusCode, CreateProject409Error, CreateProject409StatusCode, CreateProjectBodyVisibility, CreateReleaseCandidate400Error, CreateReleaseCandidate400StatusCode, CreateReleaseCandidate401Error, CreateReleaseCandidate401StatusCode, CreateReleaseCandidate403Error, CreateReleaseCandidate403StatusCode, CreateReleaseCandidate404Error, CreateReleaseCandidate404StatusCode, CreateServerAuthToken400Error, CreateServerAuthToken400StatusCode, CreateServerAuthToken401Error, CreateServerAuthToken401StatusCode, CreateServerAuthToken403Error, CreateServerAuthToken403StatusCode, CreateServerAuthToken409Error, CreateServerAuthToken409StatusCode, CreateTeam400Error, CreateTeam400StatusCode, CreateTeam401Error, CreateTeam401StatusCode, CreateTeam403Error, CreateTeam403StatusCode, CreateTeam404Error, CreateTeam404StatusCode, CreateTeam409Error, CreateTeam409StatusCode, CurrentUserOpenMembershipAutoJoinReason, CurrentUserRole, CustomDeploymentConfigPlatform, CustomIntegrationPlatform, DeactivateCurrentUser400Error, DeactivateCurrentUser400StatusCode, DeactivateCurrentUser401Error, DeactivateCurrentUser401StatusCode, DeactivateUserAccount401Error, DeactivateUserAccount401StatusCode, DeleteApplicationEnvironment401Error, DeleteApplicationEnvironment401StatusCode, DeleteApplicationEnvironment403Error, DeleteApplicationEnvironment403StatusCode, DeleteApplicationEnvironment404Error, DeleteApplicationEnvironment404StatusCode, DeleteApplicationSingular401Error, DeleteApplicationSingular401StatusCode, DeleteApplicationSingular403Error, DeleteApplicationSingular403StatusCode, DeleteApplicationSingular404Error, DeleteApplicationSingular404StatusCode, DeleteApplicationTag401Error, DeleteApplicationTag401StatusCode, DeleteApplicationTag403Error, DeleteApplicationTag403StatusCode, DeleteApplicationTag404Error, DeleteApplicationTag404StatusCode, DeleteInviteChildOrganization404Error, DeleteInviteChildOrganization404StatusCode, DeleteOrganization401Error, DeleteOrganization401StatusCode, DeleteOrganization403Error, DeleteOrganization403StatusCode, DeleteOrganization404Error, DeleteOrganization404StatusCode, DeleteOrganizationMembershipDomain401Error, DeleteOrganizationMembershipDomain401StatusCode, DeleteOrganizationMembershipDomain403Error, DeleteOrganizationMembershipDomain403StatusCode, DeleteOrganizationMembershipDomain404Error, DeleteOrganizationMembershipDomain404StatusCode, DeletePeople401Error, DeletePeople401StatusCode, DeletePeople403Error, DeletePeople403StatusCode, DeletePeople404Error, DeletePeople404StatusCode, DeleteProject401Error, DeleteProject401StatusCode, DeleteProject403Error, DeleteProject403StatusCode, DeleteProject404Error, DeleteProject404StatusCode, DeleteProjectById200ValueRole, DeleteProjectById200ValueVisibility, DeleteProjectById401Error, DeleteProjectById401StatusCode, DeleteProjectById403Error, DeleteProjectById403StatusCode, DeleteProjectById404Error, DeleteProjectById404StatusCode, DeleteReleaseCandidate401Error, DeleteReleaseCandidate401StatusCode, DeleteReleaseCandidate403Error, DeleteReleaseCandidate403StatusCode, DeleteReleaseCandidate404Error, DeleteReleaseCandidate404StatusCode, DeleteServerAuthToken401Error, DeleteServerAuthToken401StatusCode, DeleteServerAuthToken403Error, DeleteServerAuthToken403StatusCode, DeleteServerAuthToken404Error, DeleteServerAuthToken404StatusCode, DeleteTeam401Error, DeleteTeam401StatusCode, DeleteTeam403Error, DeleteTeam403StatusCode, DeleteTeam404Error, DeleteTeam404StatusCode, DeleteUserAuthToken401Error, DeleteUserAuthToken401StatusCode, DeleteUserAuthToken404Error, DeleteUserAuthToken404StatusCode, Delimiter, DeployApplicationVersion401Error, DeployApplicationVersion401StatusCode, DeployApplicationVersion403Error, DeployApplicationVersion403StatusCode, DeployApplicationVersion404Error, DeployApplicationVersion404StatusCode, DeployApplicationVersion409Error, DeployApplicationVersion409StatusCode, DeploySidePanelVersion400Error, DeploySidePanelVersion400StatusCode, DeploySidePanelVersion401Error, DeploySidePanelVersion401StatusCode, DeployTagToEnvironment400Error, DeployTagToEnvironment400StatusCode, DeployTagToEnvironment401Error, DeployTagToEnvironment401StatusCode, DeployTagToEnvironment403Error, DeployTagToEnvironment403StatusCode, DeployTagToEnvironment404Error, DeployTagToEnvironment404StatusCode, DeployTarget, DeployVersion400Error, DeployVersion400StatusCode, DeployVersion401Error, DeployVersion401StatusCode, DeployVersion403Error, DeployVersion403StatusCode, DeployVersion404Error, DeployVersion404StatusCode, DeploymentIntegrationType, DeploymentPlatform, DeploymentStatus, DetachPaymentMethod400Error, DetachPaymentMethod400StatusCode, DnsCheckResultDtoStatus, EditUserAuthToken401Error, EditUserAuthToken401StatusCode, EditUserAuthToken404Error, EditUserAuthToken404StatusCode, EntriEligibleResponsePowerStatus, EntriPowerDomain400Error, EntriPowerDomain400StatusCode, EntriPowerDomain401Error, EntriPowerDomain401StatusCode, EntriPowerDomain403Error, EntriPowerDomain403StatusCode, EntriRemovePoweredDomain401Error, EntriRemovePoweredDomain401StatusCode, EntriRemovePoweredDomain403Error, EntriRemovePoweredDomain403StatusCode, EntriRemovePoweredDomain404Error, EntriRemovePoweredDomain404StatusCode, EntriUpdatePoweredDomain400Error, EntriUpdatePoweredDomain400StatusCode, EntriUpdatePoweredDomain401Error, EntriUpdatePoweredDomain401StatusCode, EntriUpdatePoweredDomain403Error, EntriUpdatePoweredDomain403StatusCode, FastlyDeploymentConfigPlatform, FastlyIntegrationPlatform, GenerateUserAuthToken400Error, GenerateUserAuthToken400StatusCode, GenerateUserAuthToken401Error, GenerateUserAuthToken401StatusCode, GenerateUserAuthToken409Error, GenerateUserAuthToken409StatusCode, GetAccountsAssociated401Error, GetAccountsAssociated401StatusCode, GetAddEnvironmentMemberOptions401Error, GetAddEnvironmentMemberOptions401StatusCode, GetAddEnvironmentMemberOptions403Error, GetAddEnvironmentMemberOptions403StatusCode, GetAddEnvironmentMemberOptions404Error, GetAddEnvironmentMemberOptions404StatusCode, GetAppNavigationItems401Error, GetAppNavigationItems401StatusCode, GetApplication401Error, GetApplication401StatusCode, GetApplication403Error, GetApplication403StatusCode, GetApplication404Error, GetApplication404StatusCode, GetApplicationActivityOverTime401Error, GetApplicationActivityOverTime401StatusCode, GetApplicationActivityOverTime403Error, GetApplicationActivityOverTime403StatusCode, GetApplicationActivityOverTime404Error, GetApplicationActivityOverTime404StatusCode, GetApplicationActivityOverTimePeriod, GetApplicationAuditLog401Error, GetApplicationAuditLog401StatusCode, GetApplicationAuditLog403Error, GetApplicationAuditLog403StatusCode, GetApplicationAuditLog404Error, GetApplicationAuditLog404StatusCode, GetApplicationAuditLogAuthors401Error, GetApplicationAuditLogAuthors401StatusCode, GetApplicationAuditLogAuthors403Error, GetApplicationAuditLogAuthors403StatusCode, GetApplicationAuditLogAuthors404Error, GetApplicationAuditLogAuthors404StatusCode, GetApplicationConsumers401Error, GetApplicationConsumers401StatusCode, GetApplicationConsumers403Error, GetApplicationConsumers403StatusCode, GetApplicationConsumers404Error, GetApplicationConsumers404StatusCode, GetApplicationContributors401Error, GetApplicationContributors401StatusCode, GetApplicationContributors403Error, GetApplicationContributors403StatusCode, GetApplicationContributors404Error, GetApplicationContributors404StatusCode, GetApplicationContributorsWithVersionCount401Error, GetApplicationContributorsWithVersionCount401StatusCode, GetApplicationContributorsWithVersionCount403Error, GetApplicationContributorsWithVersionCount403StatusCode, GetApplicationContributorsWithVersionCount404Error, GetApplicationContributorsWithVersionCount404StatusCode, GetApplicationContributorsWithVersionCountPeriod, GetApplicationCounters401Error, GetApplicationCounters401StatusCode, GetApplicationCounters403Error, GetApplicationCounters403StatusCode, GetApplicationCounters404Error, GetApplicationCounters404StatusCode, GetApplicationEnvironment200ValueConditionChannel, GetApplicationEnvironment401Error, GetApplicationEnvironment401StatusCode, GetApplicationEnvironment403Error, GetApplicationEnvironment403StatusCode, GetApplicationEnvironment404Error, GetApplicationEnvironment404StatusCode, GetApplicationGraph401Error, GetApplicationGraph401StatusCode, GetApplicationGraph403Error, GetApplicationGraph403StatusCode, GetApplicationGraph404Error, GetApplicationGraph404StatusCode, GetApplicationGraph409Error, GetApplicationGraph409StatusCode, GetApplicationIntegrationList401Error, GetApplicationIntegrationList401StatusCode, GetApplicationIntegrationList404Error, GetApplicationIntegrationList404StatusCode, GetApplicationListByProject401Error, GetApplicationListByProject401StatusCode, GetApplicationListByProject403Error, GetApplicationListByProject403StatusCode, GetApplicationListByProjectSortOrder, GetApplicationModule401Error, GetApplicationModule401StatusCode, GetApplicationModule403Error, GetApplicationModule403StatusCode, GetApplicationModule404Error, GetApplicationModule404StatusCode, GetApplicationOverview401Error, GetApplicationOverview401StatusCode, GetApplicationOverview403Error, GetApplicationOverview403StatusCode, GetApplicationOverview404Error, GetApplicationOverview404StatusCode, GetApplicationSettings401Error, GetApplicationSettings401StatusCode, GetApplicationSettings403Error, GetApplicationSettings403StatusCode, GetApplicationSettings404Error, GetApplicationSettings404StatusCode, GetApplicationSidebarList401Error, GetApplicationSidebarList401StatusCode, GetApplicationSidebarList403Error, GetApplicationSidebarList403StatusCode, GetApplicationSummary401Error, GetApplicationSummary401StatusCode, GetApplicationSummary403Error, GetApplicationSummary403StatusCode, GetApplicationSummary404Error, GetApplicationSummary404StatusCode, GetApplicationTag401Error, GetApplicationTag401StatusCode, GetApplicationTag403Error, GetApplicationTag403StatusCode, GetApplicationTag404Error, GetApplicationTag404StatusCode, GetApplicationTagConditionOptions401Error, GetApplicationTagConditionOptions401StatusCode, GetApplicationTagConditionOptions403Error, GetApplicationTagConditionOptions403StatusCode, GetApplicationTagConditionOptionsUsers401Error, GetApplicationTagConditionOptionsUsers401StatusCode, GetApplicationTagConditionOptionsUsers403Error, GetApplicationTagConditionOptionsUsers403StatusCode, GetApplicationTagConditionOptionsVersions401Error, GetApplicationTagConditionOptionsVersions401StatusCode, GetApplicationTagConditionOptionsVersions403Error, GetApplicationTagConditionOptionsVersions403StatusCode, GetApplicationTagConditionVersion401Error, GetApplicationTagConditionVersion401StatusCode, GetApplicationTagConditionVersion403Error, GetApplicationTagConditionVersion403StatusCode, GetApplicationTagQueryOpts401Error, GetApplicationTagQueryOpts401StatusCode, GetApplicationTagQueryOpts403Error, GetApplicationTagQueryOpts403StatusCode, GetApplicationTagQueryOpts404Error, GetApplicationTagQueryOpts404StatusCode, GetApplicationUmlSidebar401Error, GetApplicationUmlSidebar401StatusCode, GetApplicationUmlSidebar403Error, GetApplicationUmlSidebar403StatusCode, GetApplicationUmlSidebar404Error, GetApplicationUmlSidebar404StatusCode, GetApplicationVersionDeployTargetList401Error, GetApplicationVersionDeployTargetList401StatusCode, GetApplicationVersionDeployTargetList403Error, GetApplicationVersionDeployTargetList403StatusCode, GetApplicationVersionDetail401Error, GetApplicationVersionDetail401StatusCode, GetApplicationVersionDetail403Error, GetApplicationVersionDetail403StatusCode, GetApplicationVersionDetail404Error, GetApplicationVersionDetail404StatusCode, GetApplicationVersionList401Error, GetApplicationVersionList401StatusCode, GetApplicationVersionList403Error, GetApplicationVersionList403StatusCode, GetApplicationVersionList404Error, GetApplicationVersionList404StatusCode, GetApplicationVersionListSortOrder, GetApplicationVersionQueryOpts401Error, GetApplicationVersionQueryOpts401StatusCode, GetApplicationVersionQueryOpts403Error, GetApplicationVersionQueryOpts403StatusCode, GetAuthorizeLink400Error, GetAuthorizeLink400StatusCode, GetAuthorizeLinkOrigin, GetAuthorizeWithUserInfo400Error, GetAuthorizeWithUserInfo400StatusCode, GetAuthorizeWithUserInfoOrigin, GetBuildVersionDetail401Error, GetBuildVersionDetail401StatusCode, GetBuildVersionDetail403Error, GetBuildVersionDetail403StatusCode, GetBuildVersionDetail404Error, GetBuildVersionDetail404StatusCode, GetBuildVersionList401Error, GetBuildVersionList401StatusCode, GetBuildVersionList403Error, GetBuildVersionList403StatusCode, GetBuildVersionList404Error, GetBuildVersionList404StatusCode, GetBuildVersionListSortOrder, GetCurrentUser401Error, GetCurrentUser401StatusCode, GetCurrentUser404Error, GetCurrentUser404StatusCode, GetCurrentUserOrganizationList401Error, GetCurrentUserOrganizationList401StatusCode, GetCurrentUserProfile401Error, GetCurrentUserProfile401StatusCode, GetCurrentUserProfile404Error, GetCurrentUserProfile404StatusCode, GetDefaultPaymentMethod404Error, GetDefaultPaymentMethod404StatusCode, GetDeployApplicationVersionList401Error, GetDeployApplicationVersionList401StatusCode, GetDeployApplicationVersionList403Error, GetDeployApplicationVersionList403StatusCode, GetDeployApplicationVersionListType, GetDeployTargets401Error, GetDeployTargets401StatusCode, GetDeployTargets403Error, GetDeployTargets403StatusCode, GetDeployTargets404Error, GetDeployTargets404StatusCode, GetDeployedVersions401Error, GetDeployedVersions401StatusCode, GetDeployedVersions403Error, GetDeployedVersions403StatusCode, GetDeployedVersions404Error, GetDeployedVersions404StatusCode, GetDeployedVersionsType, GetDeploymentIntegration401Error, GetDeploymentIntegration401StatusCode, GetDeploymentIntegration404Error, GetDeploymentIntegration404StatusCode, GetDeploymentStatus401Error, GetDeploymentStatus401StatusCode, GetDeploymentStatus404Error, GetDeploymentStatus404StatusCode, GetEmailPreferences401Error, GetEmailPreferences401StatusCode, GetEnabledList401Error, GetEnabledList401StatusCode, GetEnabledList404Error, GetEnabledList404StatusCode, GetEntriConfig401Error, GetEntriConfig401StatusCode, GetEntriConfig403Error, GetEntriConfig403StatusCode, GetEntriConfig404Error, GetEntriConfig404StatusCode, GetEntriConnectUrl400Error, GetEntriConnectUrl400StatusCode, GetEntriConnectUrl401Error, GetEntriConnectUrl401StatusCode, GetEntriConnectUrl403Error, GetEntriConnectUrl403StatusCode, GetEntriDomainEligibility400Error, GetEntriDomainEligibility400StatusCode, GetEntriDomainEligibility401Error, GetEntriDomainEligibility401StatusCode, GetEntriDomainEligibility403Error, GetEntriDomainEligibility403StatusCode, GetEnvironmentAuditLog401Error, GetEnvironmentAuditLog401StatusCode, GetEnvironmentAuditLog403Error, GetEnvironmentAuditLog403StatusCode, GetEnvironmentAuditLog404Error, GetEnvironmentAuditLog404StatusCode, GetEnvironmentAuthors401Error, GetEnvironmentAuthors401StatusCode, GetEnvironmentAuthors403Error, GetEnvironmentAuthors403StatusCode, GetEnvironmentAuthors404Error, GetEnvironmentAuthors404StatusCode, GetEnvironmentConditionOptions401Error, GetEnvironmentConditionOptions401StatusCode, GetEnvironmentConditionOptions403Error, GetEnvironmentConditionOptions403StatusCode, GetEnvironmentConditionVersion401Error, GetEnvironmentConditionVersion401StatusCode, GetEnvironmentConditionVersion403Error, GetEnvironmentConditionVersion403StatusCode, GetEnvironmentConditionVersionChannel, GetEnvironmentDependencies401Error, GetEnvironmentDependencies401StatusCode, GetEnvironmentDependencies403Error, GetEnvironmentDependencies403StatusCode, GetEnvironmentDependencies404Error, GetEnvironmentDependencies404StatusCode, GetEnvironmentDeploymentIntegrationList401Error, GetEnvironmentDeploymentIntegrationList401StatusCode, GetEnvironmentDeploymentIntegrationList404Error, GetEnvironmentDeploymentIntegrationList404StatusCode, GetEnvironmentDeploymentLog401Error, GetEnvironmentDeploymentLog401StatusCode, GetEnvironmentDeploymentLog403Error, GetEnvironmentDeploymentLog403StatusCode, GetEnvironmentDeploymentLog404Error, GetEnvironmentDeploymentLog404StatusCode, GetEnvironmentEnvVarSet401Error, GetEnvironmentEnvVarSet401StatusCode, GetEnvironmentEnvVarSet403Error, GetEnvironmentEnvVarSet403StatusCode, GetEnvironmentEnvVarSet404Error, GetEnvironmentEnvVarSet404StatusCode, GetEnvironmentIntegrations401Error, GetEnvironmentIntegrations401StatusCode, GetEnvironmentIntegrations404Error, GetEnvironmentIntegrations404StatusCode, GetEnvironmentList200EntitiesItemConditionChannel, GetEnvironmentList401Error, GetEnvironmentList401StatusCode, GetEnvironmentList403Error, GetEnvironmentList403StatusCode, GetEnvironmentListSortBy, GetEnvironmentListSortOrder, GetEnvironmentMembers401Error, GetEnvironmentMembers401StatusCode, GetEnvironmentMembers403Error, GetEnvironmentMembers403StatusCode, GetEnvironmentMembers404Error, GetEnvironmentMembers404StatusCode, GetHealth200Database, GetHealth200Redis, GetHealth200Status, GetHealthLiveness200Status, GetHealthReadiness200Status, GetHealthReadiness503Status, GetInviteInformation404Error, GetInviteInformation404StatusCode, GetList401Error, GetList401StatusCode, GetList403Error, GetList403StatusCode, GetList404Error, GetList404StatusCode, GetMultiCdnList401Error, GetMultiCdnList401StatusCode, GetMultiCdnList404Error, GetMultiCdnList404StatusCode, GetNodeDetails401Error, GetNodeDetails401StatusCode, GetNodeDetails404Error, GetNodeDetails404StatusCode, GetNodeDetails409Error, GetNodeDetails409StatusCode, GetOrgNavigationItems401Error, GetOrgNavigationItems401StatusCode, GetOrganization401Error, GetOrganization401StatusCode, GetOrganization403Error, GetOrganization403StatusCode, GetOrganization404Error, GetOrganization404StatusCode, GetOrganizationApplicationList401Error, GetOrganizationApplicationList401StatusCode, GetOrganizationApplicationList403Error, GetOrganizationApplicationList403StatusCode, GetOrganizationApplicationList404Error, GetOrganizationApplicationList404StatusCode, GetOrganizationApplicationListSort, GetOrganizationApplicationListType, GetOrganizationCounters401Error, GetOrganizationCounters401StatusCode, GetOrganizationCounters403Error, GetOrganizationCounters403StatusCode, GetOrganizationCounters404Error, GetOrganizationCounters404StatusCode, GetOrganizationMembershipDomains401Error, GetOrganizationMembershipDomains401StatusCode, GetOrganizationMembershipDomains403Error, GetOrganizationMembershipDomains403StatusCode, GetOrganizationMembershipDomains404Error, GetOrganizationMembershipDomains404StatusCode, GetPeopleList401Error, GetPeopleList401StatusCode, GetPeopleList403Error, GetPeopleList403StatusCode, GetPeopleList404Error, GetPeopleList404StatusCode, GetProjNavigationItems401Error, GetProjNavigationItems401StatusCode, GetProject200ValueRole, GetProject200ValueVisibility, GetProject401Error, GetProject401StatusCode, GetProject403Error, GetProject403StatusCode, GetProject404Error, GetProject404StatusCode, GetProjectApplicationList401Error, GetProjectApplicationList401StatusCode, GetProjectApplicationList403Error, GetProjectApplicationList403StatusCode, GetProjectApplicationList404Error, GetProjectApplicationList404StatusCode, GetProjectApplicationListByProjectName401Error, GetProjectApplicationListByProjectName401StatusCode, GetProjectApplicationListByProjectName403Error, GetProjectApplicationListByProjectName403StatusCode, GetProjectApplicationListByProjectNameSortOrder, GetProjectApplicationSidebarList401Error, GetProjectApplicationSidebarList401StatusCode, GetProjectApplicationSidebarList403Error, GetProjectApplicationSidebarList403StatusCode, GetProjectAuditLog401Error, GetProjectAuditLog401StatusCode, GetProjectAuditLog403Error, GetProjectAuditLog403StatusCode, GetProjectAuditLog404Error, GetProjectAuditLog404StatusCode, GetProjectAuditLogAuthors401Error, GetProjectAuditLogAuthors401StatusCode, GetProjectAuditLogAuthors403Error, GetProjectAuditLogAuthors403StatusCode, GetProjectAuditLogAuthors404Error, GetProjectAuditLogAuthors404StatusCode, GetProjectDeploymentIntegrationApps401Error, GetProjectDeploymentIntegrationApps401StatusCode, GetProjectDeploymentIntegrationApps404Error, GetProjectDeploymentIntegrationApps404StatusCode, GetProjectIncludeItem, GetProjectIntegrationList401Error, GetProjectIntegrationList401StatusCode, GetProjectIntegrationList404Error, GetProjectIntegrationList404StatusCode, GetProjectSettings401Error, GetProjectSettings401StatusCode, GetProjectSettings403Error, GetProjectSettings403StatusCode, GetProjectSettings404Error, GetProjectSettings404StatusCode, GetProjectSidebarSearch401Error, GetProjectSidebarSearch401StatusCode, GetProjectSidebarSearch403Error, GetProjectSidebarSearch403StatusCode, GetProjectSummary200ValueVisibility, GetProjectSummary401Error, GetProjectSummary401StatusCode, GetProjectSummary403Error, GetProjectSummary403StatusCode, GetProjectSummary404Error, GetProjectSummary404StatusCode, GetReleasePipelineByApplicationList401Error, GetReleasePipelineByApplicationList401StatusCode, GetReleasePipelineByApplicationList403Error, GetReleasePipelineByApplicationList403StatusCode, GetReleasePipelineByOrgList401Error, GetReleasePipelineByOrgList401StatusCode, GetReleasePipelineByOrgList403Error, GetReleasePipelineByOrgList403StatusCode, GetReleasePipelineByProjectList401Error, GetReleasePipelineByProjectList401StatusCode, GetReleasePipelineByProjectList403Error, GetReleasePipelineByProjectList403StatusCode, GetReleasePipelineEnvironmentList401Error, GetReleasePipelineEnvironmentList401StatusCode, GetReleasePipelineEnvironmentList403Error, GetReleasePipelineEnvironmentList403StatusCode, GetReleasePipelineTagList401Error, GetReleasePipelineTagList401StatusCode, GetReleasePipelineTagList403Error, GetReleasePipelineTagList403StatusCode, GetReleasePipelineTargetAuthors401Error, GetReleasePipelineTargetAuthors401StatusCode, GetReleasePipelineTargetAuthors403Error, GetReleasePipelineTargetAuthors403StatusCode, GetReleasePipelineTargetList401Error, GetReleasePipelineTargetList401StatusCode, GetReleasePipelineTargetList403Error, GetReleasePipelineTargetList403StatusCode, GetReleasePipelineTargetListType, GetServerAuthToken401Error, GetServerAuthToken401StatusCode, GetServerAuthToken403Error, GetServerAuthToken403StatusCode, GetServerAuthToken404Error, GetServerAuthToken404StatusCode, GetServerAuthTokenList401Error, GetServerAuthTokenList401StatusCode, GetServerAuthTokenList403Error, GetServerAuthTokenList403StatusCode, GetSidePanelApplicationEnvironmentList401Error, GetSidePanelApplicationEnvironmentList401StatusCode, GetSidePanelApplicationEnvironmentList404Error, GetSidePanelApplicationEnvironmentList404StatusCode, GetSidePanelApplicationList401Error, GetSidePanelApplicationList401StatusCode, GetSidePanelApplicationRemoteVersions400Error, GetSidePanelApplicationRemoteVersions400StatusCode, GetSidePanelApplicationRemoteVersions401Error, GetSidePanelApplicationRemoteVersions401StatusCode, GetSidePanelApplicationTagList401Error, GetSidePanelApplicationTagList401StatusCode, GetSidePanelApplicationTagList404Error, GetSidePanelApplicationTagList404StatusCode, GetSidePanelApplicationVersionList401Error, GetSidePanelApplicationVersionList401StatusCode, GetSidePanelApplicationVersionList404Error, GetSidePanelApplicationVersionList404StatusCode, GetSidePanelDeployedVersionsList400Error, GetSidePanelDeployedVersionsList400StatusCode, GetSidePanelDeployedVersionsList401Error, GetSidePanelDeployedVersionsList401StatusCode, GetSpAppEnvironment401Error, GetSpAppEnvironment401StatusCode, GetSpAppEnvironment404Error, GetSpAppEnvironment404StatusCode, GetSpAppTagList401Error, GetSpAppTagList401StatusCode, GetSpAppTagList404Error, GetSpAppTagList404StatusCode, GetSpAppVersion400Error, GetSpAppVersion400StatusCode, GetSpAppVersion401Error, GetSpAppVersion401StatusCode, GetSpAppVersionList401Error, GetSpAppVersionList401StatusCode, GetSpAppVersionList404Error, GetSpAppVersionList404StatusCode, GetSpApplicationList401Error, GetSpApplicationList401StatusCode, GetSpVersionDeployList400Error, GetSpVersionDeployList400StatusCode, GetSpVersionDeployList401Error, GetSpVersionDeployList401StatusCode, GetStripeSubscriptionItems404Error, GetStripeSubscriptionItems404StatusCode, GetSubscription401Error, GetSubscription401StatusCode, GetSubscription403Error, GetSubscription403StatusCode, GetSubscription404Error, GetSubscription404StatusCode, GetTagList401Error, GetTagList401StatusCode, GetTagList403Error, GetTagList403StatusCode, GetTagList404Error, GetTagList404StatusCode, GetTagListSortOrder, GetTargetHistory401Error, GetTargetHistory401StatusCode, GetTargetHistory403Error, GetTargetHistory403StatusCode, GetTargetHistory404Error, GetTargetHistory404StatusCode, GetTeam401Error, GetTeam401StatusCode, GetTeam403Error, GetTeam403StatusCode, GetTeam404Error, GetTeam404StatusCode, GetTeamByName401Error, GetTeamByName401StatusCode, GetTeamByName403Error, GetTeamByName403StatusCode, GetTeamByName404Error, GetTeamByName404StatusCode, GetTeamList401Error, GetTeamList401StatusCode, GetTeamList403Error, GetTeamList403StatusCode, GetTeamList404Error, GetTeamList404StatusCode, GetTeamMembers401Error, GetTeamMembers401StatusCode, GetTeamMembers403Error, GetTeamMembers403StatusCode, GetTeamMembers404Error, GetTeamMembers404StatusCode, GetUniqueOrganizationName401Error, GetUniqueOrganizationName401StatusCode, GetUniqueProjectName401Error, GetUniqueProjectName401StatusCode, GetUniqueTeamName401Error, GetUniqueTeamName401StatusCode, GetUniqueTeamName404Error, GetUniqueTeamName404StatusCode, GetUpcomingInvoice400Error, GetUpcomingInvoice400StatusCode, GetUpcomingInvoice404Error, GetUpcomingInvoice404StatusCode, GetUserApplicationListByEmail401Error, GetUserApplicationListByEmail401StatusCode, GetUserApplicationListByEmail404Error, GetUserApplicationListByEmail404StatusCode, GetUserApplicationListByEmailSort, GetUserApplicationListByEmailType, GetUserAuthToken401Error, GetUserAuthToken401StatusCode, GetUserAuthToken404Error, GetUserAuthToken404StatusCode, GetUserByUsername401Error, GetUserByUsername401StatusCode, GetUserEmailOptions401Error, GetUserEmailOptions401StatusCode, GetUserEmailOptions404Error, GetUserEmailOptions404StatusCode, GetUserOrganizationListByEmail401Error, GetUserOrganizationListByEmail401StatusCode, GetUserOrganizationListByEmail404Error, GetUserOrganizationListByEmail404StatusCode, GetUserOrganizations401Error, GetUserOrganizations401StatusCode, GetUserPinOptions401Error, GetUserPinOptions401StatusCode, GetUserPins401Error, GetUserPins401StatusCode, GetUserPins404Error, GetUserPins404StatusCode, GetUserProfileSettings401Error, GetUserProfileSettings401StatusCode, GetUserProfileSettings404Error, GetUserProfileSettings404StatusCode, GetUserProjectListByEmail401Error, GetUserProjectListByEmail401StatusCode, GetUserProjectListByEmail404Error, GetUserProjectListByEmail404StatusCode, GetUserProjectListByEmailSort, GetUserProjectListByEmailType, GraphCurrentUsage404Error, GraphCurrentUsage404StatusCode, GraphMetricBodyDtoMetricsItem, GraphMetricBodyDtoSpan, GraphMetricResultDtoMetric, GraphNodeDataEntityType, GraphNodeDataStatus, InviteChildOrganization400Error, InviteChildOrganization400StatusCode, InviteInformationDtoCycle, InviteInformationDtoTier, InvitePeople400Error, InvitePeople400StatusCode, InvitePeople401Error, InvitePeople401StatusCode, InvitePeople403Error, InvitePeople403StatusCode, InvitePeople404Error, InvitePeople404StatusCode, InvitePeople409Error, InvitePeople409StatusCode, IsServerAuthTokenNameUnique401Error, IsServerAuthTokenNameUnique401StatusCode, IsServerAuthTokenNameUnique403Error, IsServerAuthTokenNameUnique403StatusCode, IsUniqueOrganizationName401Error, IsUniqueOrganizationName401StatusCode, IsUniqueUsername401Error, IsUniqueUsername401StatusCode, IsUserAuthTokenNameUnique401Error, IsUserAuthTokenNameUnique401StatusCode, IsUserZephyrTeam401Error, IsUserZephyrTeam401StatusCode, KubernetesDeploymentConfigPlatform, KubernetesIntegrationPlatform, ListChildOrganizations404Error, ListChildOrganizations404StatusCode, ListCurrentMetricUsage404Error, ListCurrentMetricUsage404StatusCode, ListCurrentUsage404Error, ListCurrentUsage404StatusCode, ListInvoices404Error, ListInvoices404StatusCode, ListInvoicesStatus, ListOrganizationMembers401Error, ListOrganizationMembers401StatusCode, ListOrganizationMembers403Error, ListOrganizationMembers403StatusCode, ListOrganizationMembers404Error, ListOrganizationMembers404StatusCode, ListOrganizationProjects401Error, ListOrganizationProjects401StatusCode, ListOrganizationProjects403Error, ListOrganizationProjects403StatusCode, ListOrganizations401Error, ListOrganizations401StatusCode, ListPaymentMethods404Error, ListPaymentMethods404StatusCode, ListProjectContributors401Error, ListProjectContributors401StatusCode, ListProjectContributors403Error, ListProjectContributors403StatusCode, ListProjectContributors404Error, ListProjectContributors404StatusCode, ListProjectContributorsList401Error, ListProjectContributorsList401StatusCode, ListProjectContributorsList403Error, ListProjectContributorsList403StatusCode, ListProjectContributorsList404Error, ListProjectContributorsList404StatusCode, ListQuotas404Error, ListQuotas404StatusCode, ListUserAuthTokens401Error, ListUserAuthTokens401StatusCode, MultiCdnIntegrationPlatform, NavigationItemsType, NetlifyDeploymentConfigPlatform, NetlifyIntegrationPlatform, NewPeopleRole, NewProjectContributorType, Operator, OrganizationDefaultRole, OrganizationMemberRole, OrganizationMembershipDomainStatus, OrganizationPeopleRole, OrganizationSubscriptionTier, OrganizationTeamRole, PeopleRole, PinNavigationItem400Error, PinNavigationItem400StatusCode, PinNavigationItem401Error, PinNavigationItem401StatusCode, PostSpVersionDeploy400Error, PostSpVersionDeploy400StatusCode, PostSpVersionDeploy401Error, PostSpVersionDeploy401StatusCode, ProjectAuditLogAction, ProjectAuditLogResult, ProjectAuditLogType, ProjectContributorResponseRole, ProjectContributorResponseType, ProjectContributorRole, ProjectList200EntitiesItemVisibility, ProjectList401Error, ProjectList401StatusCode, ProjectList403Error, ProjectList403StatusCode, ProjectList404Error, ProjectList404StatusCode, ProjectListSort, ProjectListType, PromoteReleaseCandidate400Error, PromoteReleaseCandidate400StatusCode, PromoteReleaseCandidate401Error, PromoteReleaseCandidate401StatusCode, PromoteReleaseCandidate403Error, PromoteReleaseCandidate403StatusCode, PromoteReleaseCandidate404Error, PromoteReleaseCandidate404StatusCode, RejectChildOrganizationInvite404Error, RejectChildOrganizationInvite404StatusCode, RemoveApplicationVersionProblematic401Error, RemoveApplicationVersionProblematic401StatusCode, RemoveApplicationVersionProblematic403Error, RemoveApplicationVersionProblematic403StatusCode, RemoveApplicationVersionProblematic404Error, RemoveApplicationVersionProblematic404StatusCode, RemoveCoupon404Error, RemoveCoupon404StatusCode, RemoveEnvironmentCustomDomain401Error, RemoveEnvironmentCustomDomain401StatusCode, RemoveEnvironmentCustomDomain403Error, RemoveEnvironmentCustomDomain403StatusCode, RemoveEnvironmentCustomDomain404Error, RemoveEnvironmentCustomDomain404StatusCode, RemoveEnvironmentMember401Error, RemoveEnvironmentMember401StatusCode, RemoveEnvironmentMember403Error, RemoveEnvironmentMember403StatusCode, RemoveEnvironmentMember404Error, RemoveEnvironmentMember404StatusCode, RemoveIntegrationFromEnvironment401Error, RemoveIntegrationFromEnvironment401StatusCode, RemoveIntegrationFromEnvironment403Error, RemoveIntegrationFromEnvironment403StatusCode, RemoveIntegrationFromEnvironment404Error, RemoveIntegrationFromEnvironment404StatusCode, RemoveProjectMember401Error, RemoveProjectMember401StatusCode, RemoveProjectMember403Error, RemoveProjectMember403StatusCode, RemoveProjectMember404Error, RemoveProjectMember404StatusCode, RemoveProjectTeam401Error, RemoveProjectTeam401StatusCode, RemoveProjectTeam403Error, RemoveProjectTeam403StatusCode, RemoveProjectTeam404Error, RemoveProjectTeam404StatusCode, RemoveTeamMember401Error, RemoveTeamMember401StatusCode, RemoveTeamMember403Error, RemoveTeamMember403StatusCode, RemoveTeamMember404Error, RemoveTeamMember404StatusCode, RenameApplicationEnvironment401Error, RenameApplicationEnvironment401StatusCode, RenameApplicationEnvironment403Error, RenameApplicationEnvironment403StatusCode, RenameApplicationEnvironment404Error, RenameApplicationEnvironment404StatusCode, RenameApplicationEnvironment409Error, RenameApplicationEnvironment409StatusCode, RenameApplicationTag401Error, RenameApplicationTag401StatusCode, RenameApplicationTag403Error, RenameApplicationTag403StatusCode, RenameApplicationTag404Error, RenameApplicationTag404StatusCode, RenameApplicationTag409Error, RenameApplicationTag409StatusCode, ResendVerificationEmail400Error, ResendVerificationEmail400StatusCode, ResendVerificationEmail401Error, ResendVerificationEmail401StatusCode, ResolutionMetadataSource, ResolvedDependencyWithMetadataDependencyType, RestoreProject200ValueRole, RestoreProject200ValueVisibility, RestoreProject401Error, RestoreProject401StatusCode, RestoreProject403Error, RestoreProject403StatusCode, RestoreProject404Error, RestoreProject404StatusCode, RestoreProject409Error, RestoreProject409StatusCode, Retry401Error, Retry401StatusCode, Retry403Error, Retry403StatusCode, Retry404Error, Retry404StatusCode, RollbackEnvironment400Error, RollbackEnvironment400StatusCode, RollbackEnvironment401Error, RollbackEnvironment401StatusCode, RollbackEnvironment403Error, RollbackEnvironment403StatusCode, RollbackEnvironment404Error, RollbackEnvironment404StatusCode, SearchOrganizations401Error, SearchOrganizations401StatusCode, SendOrganizationMembershipDomainCode400Error, SendOrganizationMembershipDomainCode400StatusCode, SendOrganizationMembershipDomainCode401Error, SendOrganizationMembershipDomainCode401StatusCode, SendOrganizationMembershipDomainCode403Error, SendOrganizationMembershipDomainCode403StatusCode, SendOrganizationMembershipDomainCode404Error, SendOrganizationMembershipDomainCode404StatusCode, SendOrganizationMembershipDomainCode429Error, SendOrganizationMembershipDomainCode429StatusCode, SetApplicationVersionAvailable401Error, SetApplicationVersionAvailable401StatusCode, SetApplicationVersionAvailable403Error, SetApplicationVersionAvailable403StatusCode, SetApplicationVersionAvailable404Error, SetApplicationVersionAvailable404StatusCode, SetApplicationVersionDeprecated401Error, SetApplicationVersionDeprecated401StatusCode, SetApplicationVersionDeprecated403Error, SetApplicationVersionDeprecated403StatusCode, SetApplicationVersionDeprecated404Error, SetApplicationVersionDeprecated404StatusCode, SetApplicationVersionFailed401Error, SetApplicationVersionFailed401StatusCode, SetApplicationVersionFailed403Error, SetApplicationVersionFailed403StatusCode, SetApplicationVersionFailed404Error, SetApplicationVersionFailed404StatusCode, SetApplicationVersionProblematic401Error, SetApplicationVersionProblematic401StatusCode, SetApplicationVersionProblematic403Error, SetApplicationVersionProblematic403StatusCode, SetApplicationVersionProblematic404Error, SetApplicationVersionProblematic404StatusCode, SetApplicationVersionUnavailable401Error, SetApplicationVersionUnavailable401StatusCode, SetApplicationVersionUnavailable403Error, SetApplicationVersionUnavailable403StatusCode, SetApplicationVersionUnavailable404Error, SetApplicationVersionUnavailable404StatusCode, SetDefault401Error, SetDefault401StatusCode, SetDefault403Error, SetDefault403StatusCode, SetDefault404Error, SetDefault404StatusCode, SetDefaultApplicationIntegration401Error, SetDefaultApplicationIntegration401StatusCode, SetDefaultApplicationIntegration403Error, SetDefaultApplicationIntegration403StatusCode, SetDefaultApplicationIntegration404Error, SetDefaultApplicationIntegration404StatusCode, SetDefaultPaymentMethod400Error, SetDefaultPaymentMethod400StatusCode, SetDefaultProjectIntegration401Error, SetDefaultProjectIntegration401StatusCode, SetDefaultProjectIntegration403Error, SetDefaultProjectIntegration403StatusCode, SetDefaultProjectIntegration404Error, SetDefaultProjectIntegration404StatusCode, SetDeploymentIntegrationAllAppsToProjectDefault401Error, SetDeploymentIntegrationAllAppsToProjectDefault401StatusCode, SetDeploymentIntegrationAllAppsToProjectDefault403Error, SetDeploymentIntegrationAllAppsToProjectDefault403StatusCode, SetDeploymentIntegrationAllAppsToProjectDefault404Error, SetDeploymentIntegrationAllAppsToProjectDefault404StatusCode, SetEnvironmentDeploymentIntegration401Error, SetEnvironmentDeploymentIntegration401StatusCode, SetEnvironmentDeploymentIntegration403Error, SetEnvironmentDeploymentIntegration403StatusCode, SetEnvironmentDeploymentIntegration404Error, SetEnvironmentDeploymentIntegration404StatusCode, SetEnvironmentOrder400Error, SetEnvironmentOrder400StatusCode, SetEnvironmentOrder401Error, SetEnvironmentOrder401StatusCode, SetEnvironmentOrder403Error, SetEnvironmentOrder403StatusCode, SetPrimaryAccount400Error, SetPrimaryAccount400StatusCode, SetPrimaryAccount401Error, SetPrimaryAccount401StatusCode, SetPrimaryAccount404Error, SetPrimaryAccount404StatusCode, SetPrimaryIntegration401Error, SetPrimaryIntegration401StatusCode, SetPrimaryIntegration403Error, SetPrimaryIntegration403StatusCode, SetPrimaryIntegration404Error, SetPrimaryIntegration404StatusCode, SetZephyrAsDefault401Error, SetZephyrAsDefault401StatusCode, SetZephyrAsDefault403Error, SetZephyrAsDefault403StatusCode, SetZephyrAsDefault404Error, SetZephyrAsDefault404StatusCode, SetZephyrAsDefaultApplicationIntegration401Error, SetZephyrAsDefaultApplicationIntegration401StatusCode, SetZephyrAsDefaultApplicationIntegration403Error, SetZephyrAsDefaultApplicationIntegration403StatusCode, SetZephyrAsDefaultApplicationIntegration404Error, SetZephyrAsDefaultApplicationIntegration404StatusCode, SetZephyrAsDefaultEnvironmentIntegration401Error, SetZephyrAsDefaultEnvironmentIntegration401StatusCode, SetZephyrAsDefaultEnvironmentIntegration403Error, SetZephyrAsDefaultEnvironmentIntegration403StatusCode, SetZephyrAsDefaultEnvironmentIntegration404Error, SetZephyrAsDefaultEnvironmentIntegration404StatusCode, SetZephyrAsDefaultProjectIntegration401Error, SetZephyrAsDefaultProjectIntegration401StatusCode, SetZephyrAsDefaultProjectIntegration403Error, SetZephyrAsDefaultProjectIntegration403StatusCode, SetZephyrAsDefaultProjectIntegration404Error, SetZephyrAsDefaultProjectIntegration404StatusCode, SideBarProjectList401Error, SideBarProjectList401StatusCode, SideBarProjectList403Error, SideBarProjectList403StatusCode, SideBarProjectList404Error, SideBarProjectList404StatusCode, SidePanelDeployTarget, SimpleMetricQuotaDtoMetric, StripeInvoiceDtoStatus, SubscriptionDtoCycle, SubscriptionDtoScheduleReason, SubscriptionDtoScheduledTier, SubscriptionDtoTier, TagChannel, TargetListItemType, TeamMemberRole, TeamRole, TeamUserRole, ToggleEnabled401Error, ToggleEnabled401StatusCode, ToggleEnabled403Error, ToggleEnabled403StatusCode, ToggleEnabled404Error, ToggleEnabled404StatusCode, UnpinNavigationItem400Error, UnpinNavigationItem400StatusCode, UnpinNavigationItem401Error, UnpinNavigationItem401StatusCode, UnsetDefault401Error, UnsetDefault401StatusCode, UnsetDefault403Error, UnsetDefault403StatusCode, UnsetDefault404Error, UnsetDefault404StatusCode, UnsetDefaultApplicationIntegration401Error, UnsetDefaultApplicationIntegration401StatusCode, UnsetDefaultApplicationIntegration403Error, UnsetDefaultApplicationIntegration403StatusCode, UnsetDefaultApplicationIntegration404Error, UnsetDefaultApplicationIntegration404StatusCode, UnsetDefaultProjectIntegration401Error, UnsetDefaultProjectIntegration401StatusCode, UnsetDefaultProjectIntegration403Error, UnsetDefaultProjectIntegration403StatusCode, UnsetDefaultProjectIntegration404Error, UnsetDefaultProjectIntegration404StatusCode, UnsetEnvironmentDeploymentIntegration401Error, UnsetEnvironmentDeploymentIntegration401StatusCode, UnsetEnvironmentDeploymentIntegration403Error, UnsetEnvironmentDeploymentIntegration403StatusCode, UnsetEnvironmentDeploymentIntegration404Error, UnsetEnvironmentDeploymentIntegration404StatusCode, UpdateApplication400Error, UpdateApplication400StatusCode, UpdateApplication401Error, UpdateApplication401StatusCode, UpdateApplication403Error, UpdateApplication403StatusCode, UpdateApplication404Error, UpdateApplication404StatusCode, UpdateApplicationEnvironment401Error, UpdateApplicationEnvironment401StatusCode, UpdateApplicationEnvironment403Error, UpdateApplicationEnvironment403StatusCode, UpdateApplicationEnvironment404Error, UpdateApplicationEnvironment404StatusCode, UpdateApplicationEnvironmentBodyConditionChannel, UpdateApplicationName400Error, UpdateApplicationName400StatusCode, UpdateApplicationName401Error, UpdateApplicationName401StatusCode, UpdateApplicationName403Error, UpdateApplicationName403StatusCode, UpdateApplicationName404Error, UpdateApplicationName404StatusCode, UpdateApplicationName409Error, UpdateApplicationName409StatusCode, UpdateApplicationSettings401Error, UpdateApplicationSettings401StatusCode, UpdateApplicationSettings403Error, UpdateApplicationSettings403StatusCode, UpdateApplicationSettings404Error, UpdateApplicationSettings404StatusCode, UpdateApplicationTag401Error, UpdateApplicationTag401StatusCode, UpdateApplicationTag403Error, UpdateApplicationTag403StatusCode, UpdateApplicationTag404Error, UpdateApplicationTag404StatusCode, UpdateCurrentUserProfile400Error, UpdateCurrentUserProfile400StatusCode, UpdateCurrentUserProfile401Error, UpdateCurrentUserProfile401StatusCode, UpdateCurrentUserProfile404Error, UpdateCurrentUserProfile404StatusCode, UpdateEmailPreferences400Error, UpdateEmailPreferences400StatusCode, UpdateEmailPreferences401Error, UpdateEmailPreferences401StatusCode, UpdateEnvironmentDependencies401Error, UpdateEnvironmentDependencies401StatusCode, UpdateEnvironmentDependencies403Error, UpdateEnvironmentDependencies403StatusCode, UpdateEnvironmentDependencies404Error, UpdateEnvironmentDependencies404StatusCode, UpdateEnvironmentEnvVarSet401Error, UpdateEnvironmentEnvVarSet401StatusCode, UpdateEnvironmentEnvVarSet403Error, UpdateEnvironmentEnvVarSet403StatusCode, UpdateEnvironmentEnvVarSet404Error, UpdateEnvironmentEnvVarSet404StatusCode, UpdateMemberRoleRole, UpdateNonRecurringQuota400Error, UpdateNonRecurringQuota400StatusCode, UpdateOrganization400Error, UpdateOrganization400StatusCode, UpdateOrganization401Error, UpdateOrganization401StatusCode, UpdateOrganization403Error, UpdateOrganization403StatusCode, UpdateOrganization404Error, UpdateOrganization404StatusCode, UpdateOrganization409Error, UpdateOrganization409StatusCode, UpdateOrganizationDeploymentIntegration400Error, UpdateOrganizationDeploymentIntegration400StatusCode, UpdateOrganizationDeploymentIntegration401Error, UpdateOrganizationDeploymentIntegration401StatusCode, UpdateOrganizationDeploymentIntegration403Error, UpdateOrganizationDeploymentIntegration403StatusCode, UpdateOrganizationDeploymentIntegration404Error, UpdateOrganizationDeploymentIntegration404StatusCode, UpdateOrganizationName400Error, UpdateOrganizationName400StatusCode, UpdateOrganizationName401Error, UpdateOrganizationName401StatusCode, UpdateOrganizationName403Error, UpdateOrganizationName403StatusCode, UpdateOrganizationName404Error, UpdateOrganizationName404StatusCode, UpdateOrganizationName409Error, UpdateOrganizationName409StatusCode, UpdateOrganizationSettings400Error, UpdateOrganizationSettings400StatusCode, UpdateOrganizationSettings401Error, UpdateOrganizationSettings401StatusCode, UpdateOrganizationSettings403Error, UpdateOrganizationSettings403StatusCode, UpdateOrganizationSettings404Error, UpdateOrganizationSettings404StatusCode, UpdatePeople400Error, UpdatePeople400StatusCode, UpdatePeople401Error, UpdatePeople401StatusCode, UpdatePeople403Error, UpdatePeople403StatusCode, UpdatePeople404Error, UpdatePeople404StatusCode, UpdatePeopleRole, UpdateProjectById200ValueRole, UpdateProjectById200ValueVisibility, UpdateProjectById401Error, UpdateProjectById401StatusCode, UpdateProjectById403Error, UpdateProjectById403StatusCode, UpdateProjectById404Error, UpdateProjectById404StatusCode, UpdateProjectById409Error, UpdateProjectById409StatusCode, UpdateProjectByIdVisibility, UpdateProjectContributorRole, UpdateProjectContributorRole200ValueRole, UpdateProjectContributorRole401Error, UpdateProjectContributorRole401StatusCode, UpdateProjectContributorRole403Error, UpdateProjectContributorRole403StatusCode, UpdateProjectContributorRole404Error, UpdateProjectContributorRole404StatusCode, UpdateProjectContributorType, UpdateProjectName401Error, UpdateProjectName401StatusCode, UpdateProjectName403Error, UpdateProjectName403StatusCode, UpdateProjectName404Error, UpdateProjectName404StatusCode, UpdateProjectName409Error, UpdateProjectName409StatusCode, UpdateProjectSettings401Error, UpdateProjectSettings401StatusCode, UpdateProjectSettings403Error, UpdateProjectSettings403StatusCode, UpdateProjectSettings404Error, UpdateProjectSettings404StatusCode, UpdateRecurringQuota400Error, UpdateRecurringQuota400StatusCode, UpdateServerAuthToken401Error, UpdateServerAuthToken401StatusCode, UpdateServerAuthToken403Error, UpdateServerAuthToken403StatusCode, UpdateServerAuthToken404Error, UpdateServerAuthToken404StatusCode, UpdateTeam400Error, UpdateTeam400StatusCode, UpdateTeam401Error, UpdateTeam401StatusCode, UpdateTeam403Error, UpdateTeam403StatusCode, UpdateTeam404Error, UpdateTeam404StatusCode, UpdateTeam409Error, UpdateTeam409StatusCode, UpdateTeamMemberRole400Error, UpdateTeamMemberRole400StatusCode, UpdateTeamMemberRole401Error, UpdateTeamMemberRole401StatusCode, UpdateTeamMemberRole403Error, UpdateTeamMemberRole403StatusCode, UpdateTeamMemberRole404Error, UpdateTeamMemberRole404StatusCode, UpdateUser400Error, UpdateUser400StatusCode, UpdateUser401Error, UpdateUser401StatusCode, UpdateUser404Error, UpdateUser404StatusCode, UpdateUserAuthTokenName401Error, UpdateUserAuthTokenName401StatusCode, UpdateUserAuthTokenName404Error, UpdateUserAuthTokenName404StatusCode, UpdateUserAuthTokenName409Error, UpdateUserAuthTokenName409StatusCode, UpdateUserEmailOptions400Error, UpdateUserEmailOptions400StatusCode, UpdateUserEmailOptions401Error, UpdateUserEmailOptions401StatusCode, UpdateUserEmailOptions404Error, UpdateUserEmailOptions404StatusCode, UpdateUserPins400Error, UpdateUserPins400StatusCode, UpdateUserPins401Error, UpdateUserPins401StatusCode, UpdateUserProfileSettings400Error, UpdateUserProfileSettings400StatusCode, UpdateUserProfileSettings401Error, UpdateUserProfileSettings401StatusCode, UpdateUserProfileSettings404Error, UpdateUserProfileSettings404StatusCode, UpdateWorker400Error, UpdateWorker400StatusCode, UpdateWorker401Error, UpdateWorker401StatusCode, UpdateWorker403Error, UpdateWorker403StatusCode, UpdateWorker404Error, UpdateWorker404StatusCode, UpsertOrganizationMembershipDomain400Error, UpsertOrganizationMembershipDomain400StatusCode, UpsertOrganizationMembershipDomain401Error, UpsertOrganizationMembershipDomain401StatusCode, UpsertOrganizationMembershipDomain403Error, UpsertOrganizationMembershipDomain403StatusCode, UpsertOrganizationMembershipDomain404Error, UpsertOrganizationMembershipDomain404StatusCode, UpsertUser400Error, UpsertUser400StatusCode, UpsertUser401Error, UpsertUser401StatusCode, UserApplicationListItemProjectVisibility, UserPinType, UserPinVisibility, UserProjectListItemVisibility, ValidateAuthToken401Error, ValidateAuthToken401StatusCode, ValidateEnvVarPromotion401Error, ValidateEnvVarPromotion401StatusCode, ValidateEnvVarPromotion403Error, ValidateEnvVarPromotion403StatusCode, ValidateEnvVarPromotion404Error, ValidateEnvVarPromotion404StatusCode, VerifyOrganizationMembershipDomain400Error, VerifyOrganizationMembershipDomain400StatusCode, VerifyOrganizationMembershipDomain401Error, VerifyOrganizationMembershipDomain401StatusCode, VerifyOrganizationMembershipDomain403Error, VerifyOrganizationMembershipDomain403StatusCode, VerifyOrganizationMembershipDomain404Error, VerifyOrganizationMembershipDomain404StatusCode, VerifyOrganizationMembershipDomainResultReason, VersionSortField, ZephyrIntegrationPlatform, _Delete401Error, _Delete401StatusCode, _Delete403Error, _Delete403StatusCode, _Delete404Error, _Delete404StatusCode };
